/* eslint-disable react/jsx-newline */
import Tables from '@/@core/components/tables'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Slide,
  Stack,
  TableBody,
  TableContainer,
  TableHead,
  TextField,
  Tooltip,
  Typography,
  Slider,
  TooltipProps,
  tooltipClasses,
  List,
  ListItem,
  ListItemIcon,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Card,
  CardContent,
  InputBase,
  Chip,
  Divider,
  ListItemProps,
  ListItemText,
  Tabs,
  Tab,
  Pagination,
  PaginationItem
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import SearchIcon from '@mui/icons-material/Search'
import { GridColDef } from '@mui/x-data-grid'
import * as React from 'react'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import Paper from '@mui/material/Paper'
import TableRow, { TableRowProps } from '@mui/material/TableRow'
import TableCell, {
  TableCellProps,
  tableCellClasses
} from '@mui/material/TableCell'

import PencilOutline from 'mdi-material-ui/PencilOutline'
import CloseIcon from '@mui/icons-material/Close'
import { CircleSmall, Sack, Fullscreen, OpenInNew } from 'mdi-material-ui'

import { TransitionProps } from '@mui/material/transitions'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'
import {
  createUserACMGLogs,
  createUserACMGLogsByList,
  fetchAnalysisVariantDetails,
  fetchUserACMGLogs,
  fetchVariantDetails,
  getArticles,
  GetArticlesDto,
  getGoogleArticles,
  getHistoryReportsrResults,
  getLitVarArticles,
  getVarDetail,
  getVarGenebeArticles,
  GetVariantLiteratureDto,
  HistoryReportsResults,
  ObjectType,
  translate,
  TranslateDto,
  updateUserACMGLogs,
  UserACMGLogs,
  VariantDetail,
  VariantDto,
  VariationV1,
  Variation,
  getCitationsByVariation
} from '@/@core/services/app.service'
import { useRouter } from 'next/router'
import classifyACMG from './ACMGClassification'
import AnalyzeVariants from '../VariationGene/AnalyzeVariant'
import { NObject } from '@/@core/components/filter-variants'
import _ from 'lodash'
import { Article } from '../VariationGene/RelatedLiterature'
import {
  extractMetricValue,
  formatDate,
  formatScientificToDecimal,
  isWindow,
  unique
} from '@/@core/utils/utils'
import Index from '../Index'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import {
  ACMG_evidences_en,
  ACMG_evidences_zh
} from '../children/report-children/CurrentRepoet'
import { message } from 'antd'
import { classify } from './ACMGClassificationNew'

interface Paginations {
  pageSize: number
  pageNum: number
}
const StyledTableCell = styled(TableCell)<TableCellProps>(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    padding: '0px 0',
    textTransform: 'none'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '0.875rem'
  },
  '&.MuiTableCell-body': {
    padding: '5px ',
    paddingTop: 0,
    paddingBottom: 0
  }
}))

const ACMGClassification = [
  {
    key: 'Pathogenic',
    title: 'Pathogenic',
    color: 'rgba(229,38,35,0.8)',
    hoverColor: 'rgb(229,38,35,0.6)'
  },
  {
    key: 'Likely pathogenic',
    title: 'Likely Pathogenic',
    color: 'rgb(221,109,32)',
    hoverColor: 'rgb(221,109,32,0.6)'
  },
  {
    key: 'Uncertain significance',
    title: 'Uncertain Significance',
    color: 'rgb(255,180,0)',
    hoverColor: 'rgb(255,180,0,0.6)'
  },
  {
    key: 'Likely benign',
    title: 'Likely Benign',
    color: 'rgb(107,148,200)',
    hoverColor: 'rgb(107,148,200,0.6)'
  },
  {
    key: 'Benign',
    title: 'Benign',
    color: 'rgb(103,142,197)',
    hoverColor: 'rgb(103,142,197,0.6)'
  },
  {
    key: '.',
    title: 'None',
    color: 'rgb(46, 125, 50,.6)',
    hoverColor: 'rgb(46, 125, 50,0.4)'
  }
]

const StyledTableRow = styled(TableRow)<TableRowProps>(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },

  // hide last border
  '&:last-of-type td, &:last-of-type th': {
    border: 0
  }
}))

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(0,0,0)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}))

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    maxWidth: 'none'
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  },
  '& .MuiPaper-root': {
    maxWidth: '1200px'
  }
}))

const PrettoSlider = styled(Slider)({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none'
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit'
    },
    '&:before': {
      display: 'none'
    }
  },
  '& .MuiSlider-valueLabel': {
    backgroundColor: 'rgb(24,36,74)'
  },
  '& .MuiSlider-markLabel': {
    top: '-30px',
    textTransform: 'capitalize'
  },
  '& .MuiSlider-valueLabelOpen': {
    top: '-40px'
  }
})

interface Props {
  value: any
  analyzeVariants: any
  setAnalyzeVariant: any
  setIsFinish: any
  analysisInfo: any
  tabsName: string
}

export interface ClassifyACMG {
  PVS1: number
  PS: number[]
  PM: number[]
  PP: number[]
  BA1: number
  BS: number[]
  BP: number[]
}

interface Item {
  title?: string | null
  key?: string | null
  checked: boolean
  close: boolean
  color: string
  description?: string
  score?: number
}

// ** Styled Components
const ListItemStyled = styled(ListItem)<
  ListItemProps & { component?: React.ElementType }
>(({ theme }) => ({
  borderLeftWidth: '3px',
  borderLeftStyle: 'solid',
  padding: theme.spacing(0, 2),
  marginBottom: theme.spacing(1)
}))

export const strengthValue = [
  {
    title: 'Supporting',
    value: 1
  },
  {
    title: 'Moderate',
    value: 2
  },
  {
    title: 'Strong',
    value: 4
  },
  {
    title: 'VeryStrong',
    value: 8
  }
]

export const marks = [
  {
    value: 10,
    label: 'Benign',
    key: 'Benign',
    color: '#6D3895',
    max: -7,
    min: -27,
    pathogenicRating: [0.1]
  },
  {
    value: 30,
    label: 'Likely benign',
    key: 'Likely benign',
    color: '#7DA7D3',
    max: -1,
    min: -6,
    pathogenicRating: [10]
  },
  {
    value: 50,
    label: 'VUS',
    key: 'Uncertain significance',
    color: '#95AA67',
    max: 5,
    min: 0,
    pathogenicRating: [
      {
        key: 0,
        value: 18.8
      },
      {
        key: 1,
        value: 32.5
      },
      {
        key: 2,
        value: 50
      },
      {
        key: 3,
        value: 67.5
      },
      {
        key: 4,
        value: 81.2
      },
      {
        key: 5,
        value: 90
      }
    ]
  },
  {
    value: 70,
    label: 'Likely pathogenic',
    key: 'Likely pathogenic',
    color: '#DD6D20',
    max: 9,
    min: 6,
    pathogenicRating: [99]
  },
  {
    value: 90,
    label: 'Pathogenic',
    key: 'Pathogenic',
    color: '#E52623',
    max: 41,
    min: 10,
    pathogenicRating: ['>99']
  }
]

export const judgeStrength = (value: string) => {
  const arr = value.split('_')

  if (arr.length && arr.length > 1) {
    const strength = arr[1]

    return strength === 'Strong'
      ? 'S'
      : strength === 'VeryStrong'
      ? 'VS'
      : strength === 'Moderate'
      ? 'M'
      : strength === 'Supporting'
      ? 'P'
      : ''
  } else return ''
}

const createData = (
  name: string,
  benStrong1: Item,
  benStrong2: Item,
  benStrong3: Item,
  benSupporting1: Item,
  benSupporting2: Item,
  benSupporting3: Item,
  benSupporting4: Item,
  patSupporting1: Item,
  patModerate1: Item,
  patModerate2: Item,
  patStrong1: Item,
  patStrong2: Item
) => {
  return {
    name,
    benStrong1,
    benStrong2,
    benStrong3,
    benSupporting1,
    benSupporting2,
    benSupporting3,
    benSupporting4,
    patSupporting1,
    patModerate1,
    patModerate2,
    patStrong1,
    patStrong2
  }
}

function createData2(
  name: string | undefined,
  code: string | undefined,
  population: number | string | undefined,
  size: number | string | undefined,
  id: number | undefined
): any {
  return { name, code, population, size, id }
}

export const ChipBox = (props: {
  description?: string
  title?: string | null
  checked?: boolean
  fn?: any
  color: string
  close: boolean
  strength?: string
  changeStrength?: any
  disableMove?: boolean
}) => {
  const { t } = useTranslation()

  //   const [checked, setChecked] = React.useState(props.checked)
  const [open, setOpen] = React.useState(false)
  const [move, setMove] = React.useState(false)
  const [value, setValue] = React.useState('S')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value)
  }

  React.useEffect(() => {
    if (props.strength) {
      setValue(props.strength)
    }
  }, [props.strength])

  if (!props.title) return null

  return (
    <React.Fragment key={props.title}>
      <HtmlTooltip
        title={
          <React.Fragment>
            <Box>
              <Typography>{props.description}</Typography>

              {/* todo */}
            </Box>
          </React.Fragment>
        }
        placement="bottom-start"
        disableInteractive
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
          }}
          onMouseEnter={() => (props.disableMove ? '' : setMove(true))}
          onMouseLeave={() => (props.disableMove ? '' : setMove(false))}
        >
          <label
            style={{
              padding: '6px',
              border: '0.8px solid',
              borderColor: !props.checked ? props.color : '#fff',
              color: !props.checked ? props.color : 'white',
              backgroundColor: props.checked ? props.color : 'white',
              position: 'relative'
            }}
            onClick={() => {
              props.fn && props.fn(!props.checked, props.title)

              //   setChecked(!checked)
            }}
          >
            {/* {!props.checked && props.close && (
              <div
                style={{
                  position: 'absolute',
                  content: '',
                  left: '-5px',
                  top: '50%',
                  right: '-5px',
                  borderTop: '1px solid',
                  transform: ' rotate(-34deg)',
                  borderColor: props.color
                }}
              />
            )} */}

            {props.title}
          </label>

          <Box
            sx={{
              color: '#fff',
              backgroundColor: props.color,
              height: '100%',
              width: '16px',
              visibility: move ? 'initial' : 'hidden'
            }}
            onClick={() => {
              setOpen(true)
            }}
          >
            <PencilOutline
              sx={{
                fontSize: '16px',
                height: '34px'
              }}
            />
          </Box>
        </div>
      </HtmlTooltip>

      <BootstrapDialog
        onClose={() => setOpen(!open)}
        aria-labelledby="customized-dialog-title"
        open={open}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('update')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setOpen(!open)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              <FormControlLabel
                value="VS"
                control={<Radio />}
                label="Very Strong"
              />

              <FormControlLabel value="S" control={<Radio />} label="Strong" />

              <FormControlLabel
                value="M"
                control={<Radio />}
                label="Moderate"
              />

              <FormControlLabel
                value="P"
                control={<Radio />}
                label="Supporting"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Stack direction="row" spacing={4} padding={'10px 0'}>
            <Button
              variant="outlined"
              size="small"
              autoFocus
              onClick={() => setOpen(!open)}
            >
              {t('close')}
            </Button>

            <Button
              variant="contained"
              size="small"
              autoFocus
              onClick={() => {
                setOpen(!open)

                props.changeStrength && props.changeStrength(value)
              }}
            >
              {t('save')}
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  )
}

export const ACMGSlider = (props: {
  value: number
  title: string
  score: number
  pathogenicRating: string
}) => {
  const { t } = useTranslation()

  const valueLabelFormat = (value: number) => {
    const arr = marks
      .map((item) => {
        return {
          value: Math.abs(item.value - value),
          title: item.label,
          color: item.color
        }
      })
      .sort((a, b) => a.value - b.value)

    return (
      <Box>
        <Stack>
          <Typography fontSize={18} fontWeight={'bold'} color={arr[0].color}>
            {`${props.title}: ${arr[0].title}`}
          </Typography>

          <Typography
            fontSize={16}
            color={'black'}
            sx={{
              textTransform: 'capitalize'
            }}
          >
            {`${t('Bayesian')}:${props.score}${t('score')}， ${t(
              'Posterior probability'
            )}${props.pathogenicRating}%`}
          </Typography>
        </Stack>
      </Box>
    )
  }

  return (
    <Box width={'90%'} height={'105px'} display={'flex'} alignItems={'end'}>
      <PrettoSlider
        aria-label="Custom marks"
        defaultValue={props.value}
        step={1}
        valueLabelDisplay="on"
        marks={marks}
        disabled
        valueLabelFormat={valueLabelFormat}
        sx={{
          background:
            'linear-gradient(to right, #6D3895, #7DA7D3, #7DA7D3,#95AA67,#DD6D20,#E52623)',
          color: 'transparent !important',
          padding: 0,
          marginBottom: '0px',
          '& .MuiSlider-valueLabelOpen': {
            bgcolor: 'white',
            border: '1px solid black',
            '::before': {
              border: '1px solid black',
              borderTopColor: 'white',
              borderLeftColor: 'white'
            }
          }
        }}
      />
    </Box>
  )
}

const ACMG = React.forwardRef((props: Props, ref) => {
  const router = useRouter()
  const { t, i18n } = useTranslation()

  const ability = useContext(AbilityContext)

  const left = [
    createData(
      t('Population data'),
      {
        title: 'BA1',
        key: 'BA1',
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895',
        description: t(
          'BA1: Allele frequencies greater than 5% in ESP, ExAC, and 1000 genomes'
        )
      },
      {
        title: 'BS1',
        key: 'BS1',
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895',
        description: t(
          'BS1: allele frequency is higher than the incidence of disease'
        )
      },
      {
        title: 'BS2',
        key: 'BS2',
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895',
        description: t(
          'BS2: Homozygous mutations are detected in healthy people for completely explicit disease with early onset; For early-onset autosomal/sex-chromosomal dominant diseases, heterozygotes or hemigygotes are detected in healthy people'
        )
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: 'PM2-P',
        key: 'PM2_Supporting',
        score: 1,
        checked: false,
        close: true,
        color: '#95AA67',
        description: t(
          'PM2: The frequency in ESP, ExAC, thousand people database is 0, and the mutation frequency of recessive genetic diseases is allowed to be low frequency'
        )
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'

        // description:
        //   'PM2:在ESP、ExAC、千人数据库当中的频率为0，对于隐性遗传病的变异频率允许是低频的'
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'
      },
      {
        title: 'PS4',
        key: 'PS4',
        checked: false,
        score: 4,
        close: true,
        color: '#E52623',
        description: t(
          'PS4: Mutated gene frequency in patient group in control group'
        )
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      }
    ),
    createData(
      t('Calculate and forecast data'),
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: 'BP1',
        key: 'BP1',
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3',
        description: t(
          'BP1: Only truncated pathogenic mutations have been reported in the gene where the missense variation is located'
        )
      },
      {
        title: 'BP3',
        key: 'BP3',
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3',
        description: t(
          'BP3: Deletion or insertion variation that occurs within a sequence repeat region of unknown function'
        )
      },
      {
        title: 'BP4',
        key: 'BP4',
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3',
        description: t(
          'BP4: Multiple computer simulations predict harmlessness (conservation, evolutionary rate, splicing effects, etc.)'
        )
      },
      {
        title: 'BP7',
        key: 'BP7',
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3',
        description: t(
          'BP7: Software predicts a synonym mutation that has no effect on splicing and is located in a non-highly conserved region'
        )
      },
      {
        title: 'PP3',
        key: 'PP3',
        score: 1,
        checked: false,
        close: true,
        color: '#95AA67',
        description: t(
          'PP3: Multiple computer simulations predict harm (conservation, evolutionary rate, splicing effects, etc.)'
        )
      },
      {
        title: 'PM4',
        key: 'PM4',
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20',
        description: t(
          'PM4: Changes in protein length due to insertion/deletion mutations in non-repeating domain frames and changes in protein length due to stop codon extension'
        )
      },
      {
        title: 'PM5',
        key: 'PM5',
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20',
        description: t(
          'PM5: A missense mutation is a disease-causing mutation with a different amino acid change in the same location'
        )
      },
      {
        title: 'PS1',
        key: 'PS1',
        checked: false,
        score: 4,
        close: true,
        color: '#E52623',
        description: t(
          'PS1: The same amino acid as the known pathogenic variant, except for a different nucleotide mutation'
        )
      },
      {
        title: 'PVS1',
        key: 'PVS1',
        checked: false,
        score: 8,
        close: true,
        color: '#E52623',
        description: t('PVS1: A truncated variant in a gene known to cause LOF')
      }
    ),
    createData(
      t('Functional data'),
      {
        title: 'BS3',
        key: 'BS3',
        score: -4,
        checked: false,
        close: false,
        color: '#6D3895',
        description: t(
          'BS3: Well-established in vivo or in vitro experiments demonstrate that the mutation has no effect on the gene or gene product'
        )
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: 'PP2',
        key: 'PP2',
        score: 1,
        checked: false,
        close: true,
        color: '#95AA67',
        description: t(
          'PP2: There are very few benign variations in the gene where the missense mutation occurs, most of which are pathogenic'
        )
      },
      {
        title: 'PM1',
        key: 'PM1',
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20',
        description: t(
          'PM1: located in a mutation hotspot or very well-defined functional domain (e.g., the active site of an enzyme), and free of any benign variation in this region'
        )
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'
      },
      {
        title: 'PS3',
        key: 'PS3',
        checked: false,
        score: 4,
        close: true,
        color: '#E52623',
        description: t(
          'PS3: Well-established in vivo or in vitro experiments demonstrate that the mutation has an effect on the gene or gene product'
        )
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      }
    ),
    createData(
      t('Coseparated data'),
      {
        title: 'BS4',
        key: 'BS4',
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895',
        description: t(
          'BS4: Coisolation of nonconforming variants with disease in the family'
        )
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: 'PP1',
        key: 'PP1',
        score: 1,
        checked: false,
        close: true,
        color: '#95AA67',
        description: t(
          'PP1: The mutation and the disease are co-isolated in the family'
        )
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      }
    ),
    createData(
      t('Emerging data'),
      {
        title: null,
        score: -4,
        checked: false,
        close: false,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: 1,
        checked: false,
        close: true,
        color: '#95AA67'
      },
      {
        title: 'PM6',
        key: 'PM6',
        score: 2,
        checked: false,
        close: false,
        color: '#DD6D20',
        description: t(
          'PM6: Expected to be a novel mutation, but not confirmed by pedigree'
        )
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'
      },
      {
        title: 'PS2',
        key: 'PS2',
        score: 4,
        checked: false,
        close: false,
        color: '#E52623',
        description: t(
          'PS2: An emerging variant with family validation and no family history'
        )
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      }
    ),
    createData(
      t('Allele data'),
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: 'BP2',
        key: 'BP2',
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3',
        description: t(
          'BP2: The gene in which the mutation is located is fully autosomal dominant, another pathogenic mutation is detected, and for any gene of inherited mode, a clear pathogenic mutation is detected in the same allele'
        )
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: 1,
        checked: false,
        close: true,
        color: '#95AA67'
      },
      {
        title: 'PM3',
        key: 'PM3',
        score: 2,
        checked: false,
        close: false,
        color: '#DD6D20',
        description: t(
          'PM3: In the case of recessive inheritance, the proband detects a complex heterozygous variant, and the other mutation that constitutes the trans is a known pathogenic variant'
        )
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      }
    ),
    createData(
      t('Other data'),
      {
        title: null,
        score: -4,
        checked: false,
        close: false,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: null,
        checked: false,
        score: -4,
        close: true,
        color: '#6D3895'
      },
      {
        title: 'BP5',
        key: 'BP5',
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3',
        description: t(
          'BP5: Different molecular mechanisms are present in patients with the mutation'
        )
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: null,
        score: -1,
        checked: false,
        close: true,
        color: '#7DA7D3'
      },
      {
        title: 'PP4',
        key: 'PP4',
        score: 1,
        checked: false,
        close: true,
        color: '#95AA67',
        description: t(
          'PP4: Mutation-associated disease is highly consistent with the phenotype or family history of the patient'
        )
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'
      },
      {
        title: null,
        score: 2,
        checked: false,
        close: true,
        color: '#DD6D20'
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      },
      {
        title: null,
        checked: false,
        score: 4,
        close: true,
        color: '#E52623'
      }
    )
  ]
  const { id } = router.query

  const type = router.asPath.includes('/samples')
    ? ObjectType.SAMPLE
    : ObjectType.ANALYSIS

  const [genebe, setGenebe] = React.useState<any[]>([])
  const params = {
    gnomAD_exome_ALL: props.value.gnomAD_exome_ALL as unknown as any,
    gnomAD_genome_ALL: props.value.gnomAD_genome_ALL as unknown as any,
    MAX_AF: props.value.MAX_AF as unknown as any,
    REVEL_score: props.value.REVEL_score as unknown as any,
    SpliceAI_max_score: props.value.SpliceAI_max_score as unknown as any,
    SIFT_score: props.value.SIFT_score as unknown as any,
    CADD_phred: props.value.CADD_phred as unknown as any,
    Index: props.value.Index as unknown as any
  }

  const rightData = [
    {
      title: t('Population data'),
      tData: [
        {
          key: t('Allele frequency'),
          gAD_WES:
            params.gnomAD_exome_ALL !== '.' && params.gnomAD_genome_ALL
              ? params.gnomAD_exome_ALL
              : params.gnomAD_exome_ALL,
          gAD_WGS:
            params.gnomAD_genome_ALL !== '.' && params.gnomAD_genome_ALL
              ? params.gnomAD_genome_ALL
              : params.gnomAD_genome_ALL,
          id: 3
        },
        {
          title: t('Maximum allele frequency'),
          value: params.MAX_AF,
          id: 4
        },
        {
          title: t('Local frequency'),
          value: params.Index
            ? `${params.Index.accountTotal} / ${params.Index.platformTotal}`
            : '--',
          id: 5
        }
      ],
      tColumns: [
        {
          field: 'key',
          headerName: '',
          align: 'center',
          sortable: false
        },
        {
          field: 'gAD_WES',
          headerName: 'gAD_WES',
          align: 'center'
        },
        {
          field: 'gAD_WGS',
          headerName: 'gAD_WGS',
          align: 'center'
        }
      ] as GridColDef[]
    },
    {
      title: t('Calculate and forecast data'),
      tData: [
        {
          key: 'Revel',
          value: params.REVEL_score,
          id: 0
        },
        {
          key: 'Splice-AI ',
          value: params.SpliceAI_max_score,
          id: 2
        },
        {
          key: 'SIFT',
          value: params.SIFT_score,
          id: 3
        },
        {
          key: 'CADD_PHRED',
          value: params.CADD_phred,
          id: 4
        }
      ],
      tColumns: [] as GridColDef[]
    }
  ]

  const acmgValue = React.useMemo<{ key: string }[]>(() => {
    if (
      props.tabsName === t('MT') ||
      props.tabsName === 'MT' ||
      props.tabsName === '线粒体'
    ) {
      if (genebe && genebe.length) {
        return genebe[0]?.acmg_criteria?.split(',').map((item: string) => {
          return { key: item }
        })
      } else return []
    } else {
      if (props.value.user_acmg_classification) {
        //用户自定义评级
      }
      if (props.value.acmg_evidences)
        return props.value.acmg_evidences.map((item: string) => {
          return { key: item }
        })
      else return []
    }
  }, [props.value, props.tabsName, genebe])

  React.useEffect(() => {
    if (acmgValue && acmgValue.length) {
      left.map((items) => {
        if (typeof items === 'object') {
          Object.getOwnPropertyNames(items).map((key) => {
            const item = items[key as unknown as 'benStrong1']

            if (
              acmgValue?.some(
                (i) =>
                  i.key === item.title ||
                  i.key === item.key ||
                  i.key.includes(item.key as any) ||
                  item.key?.includes(i.key as any)
              )
            ) {
              item.checked = true
            }
          })
        }
      })

      setLeftData(left)

      setCheckoutList(acmgValue.map((item) => item.key))
    }
  }, [acmgValue])

  const [messageApi, contextHolder] = message.useMessage()
  const [score, setScore] = React.useState(0)
  const [pathogenicRating, setPathogenicRating] = React.useState('')
  const [leftData, setLeftData] = React.useState(left)
  const [open, setOpen] = React.useState(false)
  const [aiOpen, setAiOpen] = React.useState(false)
  const [allFlag, setAllFlag] = React.useState(false)
  const [logsOpen, setLogsOpen] = React.useState(false)
  const [sliderValue, setSliderValue] = React.useState<number>(79)
  const [description, setDescription] = React.useState<null | {
    color: string
    label: string
  }>()
  const [checkedList, setCheckoutList] = React.useState<string[]>(
    acmgValue.map((item) => item.key)
  )
  const Summaryref = React.useRef<any>()
  const AcmgTableref = React.useRef<any>()
  const Commentref = React.useRef<any>()
  const Otherref = React.useRef<any>()
  const Publicationref = React.useRef<any>()

  const [tabValueArticle, setTabValueArticle] = React.useState(0)
  const [tabValueArticle2, setTabValueArticle2] = React.useState(0)
  const [metCriteria, setMetCriteria] = React.useState<any[]>([])
  const [evidenceSummary, setEvidenceSummary] = React.useState('')
  const [tableData, setTableData] = React.useState<any[]>([])
  const [userAcmgData, setUserAcmgData] = React.useState<UserACMGLogs[]>([])
  const [allUserAcmgData, setAllUserAcmgData] = React.useState<UserACMGLogs[]>(
    []
  )
  const [litPage, setLitPage] = React.useState(1)

  const [variantPubmedArticles, setVariantPubmedArticles] = React.useState<
    any[]
  >([])
  const [scholarArticles, setScholarArticles] = React.useState<any[]>([])
  const [clinvarArticles, setClinvarArticles] = React.useState<any[]>([])
  const [litVarArticles, setLitVarArticles] = React.useState<{
    results: any[]
    page_size: number
    count: number
  }>({
    results: [],
    page_size: 10,
    count: 0
  })
  const [hgmdValue, setHgmdValue] = React.useState<any[]>([])
  const [leftDataValue, setLeftDataValue] = React.useState([
    {
      key: 'acmg',
      title: t('ACMG rating')
    },
    {
      key: 'comment',
      title: t('Chain of evidence')
    },
    {
      key: 'other',
      title: t('Other')
    },
    {
      key: 'Publication',
      title: t('Publication')
    }
  ])
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const [userAcmgCount, setUserAcmgCount] = React.useState(0)

  const [variantsData, setVariantsData] = React.useState<
    HistoryReportsResults[]
  >([])
  const [variantsCount, setVariantsCount] = React.useState(0)
  const [allUserAcmgCount, setAllUserAcmgCount] = React.useState(0)
  const [acmg, setAcmg] = React.useState<string[]>([])
  const [Comment, setComment] = React.useState('')
  const [summarization, setsummarization] = React.useState('')
  const [genebeEve, setGenebeEve] = React.useState('')
  const [variantsArticles, setVariantsArticles] = React.useState<any>()
  const [search, setSearch] = React.useState<string>('')
  const [searchValue, setSearchValue] = React.useState<string>('')
  const [variantDetail, setVariantDetails] = React.useState<VariantDetail>()
  const [Prediction, setPrediction] = React.useState<any[]>([])

  const [translates, setTranslates] = React.useState('')

  const column = React.useMemo(() => {
    return [
      {
        id: 'name',
        label: 'Population',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.name}</Typography>
        )
      },
      {
        id: 'code',
        label: 'gnomAD Exomes',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.code}</Typography>
        )
      },
      {
        id: 'population',
        label: 'gnomAD Genomes',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.population}</Typography>
        )
      },
      {
        id: 'size',
        label: '1000g',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.size}</Typography>
        )
      },
      {
        id: 'ExAC',
        label: 'ExAC',
        minWidth: 170,
        format: (value: any) => <Typography fontSize={14}>{value}</Typography>
      },
      {
        id: 'ALFA',
        label: 'ALFA',
        minWidth: 170,
        format: (value: any) => <Typography fontSize={14}>{value}</Typography>
      }
    ]
  }, [variantDetail])

  const columnCN = React.useMemo(() => {
    return [
      {
        id: 'WBBC_AF',
        label: 'WBBC AF',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.wbbc_af}</Typography>
        ),
        renderHeader: () => (
          <Tooltip title={t('Allele frequency in called genotypes in WBBC')}>
            <Typography>WBBC ALL</Typography>
          </Tooltip>
        )
      },
      {
        id: 'WBBC_North_AF',
        label: 'WBBC North AF',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.wbbc_north_af}</Typography>
        ),
        renderHeader: () => (
          <Tooltip title={t('Allele frequency in North Han Chinese')}>
            <Typography> North </Typography>
          </Tooltip>
        )
      },
      {
        id: 'WBBC_Central_AF',
        label: 'WBBC Central AF',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.wbbc_central_af}</Typography>
        ),
        renderHeader: () => (
          <Tooltip title={t('Allele frequency in Central Han Chinese')}>
            <Typography> Central </Typography>
          </Tooltip>
        )
      },
      {
        id: 'WBBC_South_AF',
        label: 'WBBC South AF',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.wbbc_south_af}</Typography>
        ),
        renderHeader: () => (
          <Tooltip title={t('Total number of alleles in South Han Chinese')}>
            <Typography> South </Typography>
          </Tooltip>
        )
      },
      {
        id: 'WBBC_Lingnan_AF',
        label: 'WBBC Lingnan AF',
        minWidth: 170,
        format: (value: any, row: any) => (
          <Typography fontSize={14}>{value ?? row.wbbc_lingnan_af}</Typography>
        ),
        renderHeader: () => (
          <Tooltip title={t('Allele frequency in Lingnan Han Chinese')}>
            <Typography> Lingnan </Typography>
          </Tooltip>
        )
      }
    ]
  }, [props.value])

  const rows = React.useMemo(() => {
    //
    const variantInfo = variantDetail?.variantInfo as any

    return [
      createData2(
        'Remaining',
        `${formatScientificToDecimal(variantInfo?.gnomade_remaining_af ?? 0)}`,
        `${formatScientificToDecimal(variantInfo?.gnomadg_remaining_af ?? 0)}`,
        variantInfo?.AFR_AF_1000g,
        0
      ),
      createData2(
        'African',
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_exome_AFR ?? variantInfo?.gnomade_afr_af
        )}`,
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_genome_AFR ?? variantInfo?.gnomadg_afr_af
        )}`,
        variantInfo?.AFR_AF_1000g,
        1
      ),
      createData2(
        'American',
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_exome_AMR ?? variantInfo?.gnomade_amr_af
        )}`,
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_genome_AMR ?? variantInfo?.gnomadg_amr_af
        )}`,
        variantInfo?.AMR_AF_1000g,
        2
      ),
      createData2(
        'Ashkenazi Jewish',
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_exome_ASJ ?? variantInfo?.gnomade_asj_af
        )}`,
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_genome_ASJ ?? variantInfo?.gnomadg_asj_af
        )}`,
        variantInfo?.ASJ_AF_1000g,
        3
      ),
      createData2(
        'East Asian',
        `${formatScientificToDecimal(variantInfo?.gnomAD_exome_EAS ?? 0)}`,
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_genome_EAS ?? variantInfo?.gnomadg_eass_af
        )}`,
        variantInfo?.EAS_AF_1000g,
        4
      ),
      createData2(
        'European',
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_exome_FIN ?? variantInfo?.gnomade_fin_af
        )}`,
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_genome_FIN ?? variantInfo?.gnomadg_fin_af
        )}`,
        variantInfo?.EUR_AF_1000g,
        5
      ),
      createData2(
        'Middle Eastern',
        `${formatScientificToDecimal(variantInfo?.gnomade_mid_af ?? 0)}`,
        `${formatScientificToDecimal(variantInfo?.gnomadg_mid_af ?? 0)}`,
        variantInfo?.EUR_AF_1000g,
        7
      ),
      createData2(
        'Non-Finnish European',
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_exome_NFE ?? variantInfo?.gnomade_nfe_af
        )}`,
        `${formatScientificToDecimal(
          variantInfo?.gnomAD_genome_NFE ?? variantInfo?.gnomadg_nfe_af
        )}`,
        variantInfo?.NFE_AF_1000g,
        6
      ),
      createData2(
        'Amish',
        `${formatScientificToDecimal(0)}`,
        `${formatScientificToDecimal(variantInfo?.gnomadg_ami_af ?? 0)}`,
        variantInfo?.NFE_AF_1000g,
        8
      ),
      createData2(
        'South Asian',
        `${formatScientificToDecimal(variantInfo?.gnomade_sas_af ?? 0)}`,
        `${formatScientificToDecimal(variantInfo?.gnomadg_sas_af ?? 0)}`,
        variantInfo?.SAS_AF_1000g,
        9
      )

      // createData2(
      //   'Other',
      //   `${variantInfo.gnomAD_exome_OTH}`,
      //   variantInfo.gnomAD_genome_OTH,
      //   variantInfo.gnomAD_genome_AFR,
      //   7
      // ),
    ]
  }, [variantDetail])

  const ExomesArr = rows.map((item) => {
    if (item.code === '.') {
      return 0
    } else {
      return item.code
    }
  })
  const GenomesArr = rows.map((item) => {
    if ((item.population as any) === '.') {
      return 0
    } else {
      return item.population
    }
  })

  const MAX_AF = React.useMemo(() => {
    const variantInfo = variantDetail?.variantInfo as any

    return [
      {
        key: 'MAX_AF in Gnomad Exomes:',
        value: Math.max.apply(null, ExomesArr as unknown as number[])
      },
      {
        key: 'MAX_AF in Gnomad Genomes:',
        value: Math.max.apply(null, GenomesArr)
      },
      {
        key: 'gnomAD_exome_ALL:',
        value: formatScientificToDecimal(
          variantInfo?.gnomAD_exome_ALL ?? variantInfo?.gnomade_af
        )
      },
      {
        key: 'gnomAD_genome_ALL:',
        value: formatScientificToDecimal(
          variantInfo?.gnomAD_genome_ALL ?? variantInfo?.gnomadg_af
        )
      }
    ]
  }, [variantDetail])
  const columns: GridColDef[] = [
    { field: 'id', headerName: t('Serial number'), width: 60, sortable: false },
    {
      field: 'level',
      headerName: t('Level of evidence'),
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return <div>{params.row.title.split('-').join('_').split('_')[0]}</div>
      }
    },
    {
      field: 'score',
      headerName: t('Score'),
      width: 60,
      editable: false,
      sortable: false
    },
    {
      field: 'title',
      headerName: t('Evidence'),
      width: 100,
      editable: false,
      sortable: false
    },
    {
      field: 'description',
      headerName: t('Evidence statement'),
      flex: 1,
      editable: true,
      sortable: false
    }
  ]
  const columns3: GridColDef[] = [
    { field: 'id', headerName: t('Serial number'), width: 60, sortable: false },

    {
      field: 'user',
      headerName: t('Regenerator'),
      width: 180,
      editable: false,
      sortable: false,
      renderCell: (row) => {
        return <>{row.row?.username}</>
      }
    },
    {
      field: 'acmgCriteria',
      headerName: t('Evidence'),
      width: 100,
      editable: false,
      sortable: false
    },
    {
      field: 'evidenceDetails',
      headerName: t('Evidence statement'),
      flex: 1,
      sortable: false
    },
    {
      field: 'createTime',
      headerName: t('Creation time'),
      width: 150,
      sortable: false,
      renderCell: (row) => {
        return <>{formatDate(row.row.createTime)}</>
      }
    }
  ]

  const { data } = useQuery<VariantDetail>(
    ['variantDetails'],
    async () => {
      const variants = {
        chrom: props.value.chrom,
        pos: props.value.pos,
        REF: props.value.REF ?? props.value.ref,
        ALT: props.value.ALT ?? props.value.alt,
        gene: props.value.gene,
        genomeBuild: props.analysisInfo.genomeBuild
      }

      if (type === 'sample')
        return await fetchVariantDetails({
          sampleId: id as unknown as number,
          variants
        })
      else {
        const analysisItemType = localStorage.getItem('analysisItemType')

        return await fetchAnalysisVariantDetails({
          analysisId: id as unknown as number,
          variants: {
            ...variants,
            analysisItemType
          }
        })
      }
    },
    {
      keepPreviousData: true,
      onSuccess: (variantDetails) => {
        if (props.analysisInfo.pipelineVersion) {
          setVariantDetails({
            ...variantDetails,
            variantInfo: props.value
          })

          setHgmdValue(variantDetails.hgmd)
        } else {
          setVariantDetails(variantDetails)

          setHgmdValue(variantDetails.hgmd)
        }

        const variantInfo = variantDetails.variantInfo ?? props.value
        const Prediction = Object.getOwnPropertyNames(variantInfo)
          .map((key) => {
            if (
              key === 'CADD_phred' ||
              key === 'cadd_phred' ||
              key === 'f_score' ||
              key === 'g_score' ||
              key === 'REVEL_score' ||
              key === 'revel' ||
              key === 'SpliceAI_max_score' ||
              key === 'spliceai_max_score' ||
              key === 'AM_pathogenicity' ||
              key === 'am_pathogenicity' ||
              key === 'SIFT_score' ||
              key === 'sift' ||
              key === 'polyphen2_HDIV_score' ||
              key === 'polyphen'
            ) {
              let value = variantInfo[key as 'f_score']
              if (key === 'f_score')
                value = (value * 100).toFixed(2) as unknown as number
              if (key === 'g_score')
                value = (value * 100).toFixed(2) as unknown as number
              let newkey = key
              if (key === 'f_score') newkey = 'F score'
              if (key === 'g_score') newkey = 'G score'
              if (key === 'REVEL_score') newkey = 'Revel'
              if (key === 'revel') newkey = 'Revel'
              if (key === 'AM_pathogenicity') newkey = 'AlphaM (pathogenicity)'
              if (key === 'am_pathogenicity') newkey = 'AlphaM (pathogenicity)'
              if (key === 'SpliceAI_max_score') newkey = 'SpliceAI (max.)'
              if (key === 'spliceai_max_score') newkey = 'SpliceAI (max.)'
              if (key === 'SIFT_score') newkey = 'SIFT score'
              if (key === 'sift') newkey = 'SIFT score'
              if (key === 'polyphen2_HDIV_score') newkey = 'Polyphen2'
              if (key === 'polyphen') newkey = 'Polyphen2'
              if (key === 'CADD_phred') newkey = 'CADD_PHRED'
              if (key === 'cadd_phred') newkey = 'CADD_PHRED'

              return {
                key: newkey,
                value
              }
            }
          })
          .filter((i) => i) as { key: string; value: any }[]
        const arrName: string[] = []

        Prediction.forEach((el) => {
          arrName.push(el.key)
        })

        if (arrName.indexOf('G score') > -1) {
          const filterArr = Prediction.splice(arrName.indexOf('g_score'), 1)

          Prediction.splice(0, 0, filterArr[0])
        }

        if (arrName.indexOf('F score') > -1) {
          const filterArr = Prediction.splice(arrName.indexOf('f_score'), 1)

          Prediction.splice(0, 0, filterArr[0])
        }

        setPrediction(Prediction)
      }
    }
  )

  const splitAndFormat = (input: string) => {
    // 使用下划线分割字符串

    const parts = input.split('_')

    // 根据分割后的部分数量进行处理

    if (parts.length === 2) {
      // 如果只有两个部分，直接返回它们（可能需要进行额外的格式化，这里假设不需要）

      return [parts[0], parts[1]]
    } else if (parts.length === 3) {
      // 如果有三个部分，将最后两个部分合并（移除它们之间的下划线）

      return [parts[0], parts.slice(1).join('')]
    } else {
      // 如果分割后的部分数量不符合预期，可以抛出一个错误或返回 null

      return [input, '']
    }
  }

  const NameGroupingComponent = (data: any[]) => {
    // 1. 首先按 username 分组

    const groups = {} as NObject

    data.forEach((item) => {
      const key = item.username || 'unnamed' // 处理没有 username 的情况

      if (!groups[key]) {
        groups[key] = []
      }

      groups[key].push(item)
    })

    // 2. 处理每个分组，只保留第一个 username

    const result = [] as any[]

    Object.values(groups).forEach((group) => {
      group.forEach((item: any, index: number) => {
        // 创建新对象，避免修改原数据

        const newItem = { ...item }

        if (index !== 0) {
          newItem.username = '' // 或者 null，根据需求
        }

        result.push(newItem)
      })
    })

    return result
  }

  const sumOfList = (list: number[]) => {
    let sum = 0

    for (const i of list) {
      sum += i
    }

    return sum
  }

  const classifyV2 = (
    PVS1: number,
    PS: number[],
    PM: number[],
    PP: number[],
    BA1: number,
    BS: number[],
    BP: number[],
    PVS: number[]
  ) => {
    const BPS = [
      'Pathogenic',
      'Likely pathogenic',
      'Benign',
      'Likely benign',
      'Uncertain significance'
    ]

    const BP7 = BP[6]
    const BS1 = BS[0]

    const PS_sum = sumOfList(PS)
    const PM_sum = sumOfList(PM)
    const PP_sum = sumOfList(PP)
    const BS_sum = sumOfList(BS)
    const BP_sum = sumOfList(BP)
    let PVS_sum = sumOfList(PVS)

    // Exception for only PM2_Supporting and PVS1 exist -> LP
    try {
      if (
        PVS1 === 1 &&
        PVS_sum === 0 &&
        PS_sum === 0 &&
        PM_sum === 0 &&
        PP_sum === 1 &&
        BA1 === 0 &&
        BS_sum === 0 &&
        BP_sum === 0
      ) {
        const PM2_Supporting = PP[6]

        if (PM2_Supporting === 1) {
          return BPS[1] // Likely pathogenic
        }
      }
    } catch (error) {
      console.error(error)
    }

    PVS_sum = PVS1 === 1 ? PVS_sum + 1 : PVS_sum

    if (
      (PVS_sum > 0 || PS_sum > 0 || PM_sum > 0 || PP_sum > 0) &&
      (BA1 === 1 || BS_sum > 0 || BP_sum > 0)
    ) {
      return BPS[4] // Uncertain significance
    }
    if (PVS_sum > 1) return BPS[0]

    if (
      (BP7 === 1 && BP_sum >= 3) || // M5
      BA1 === 1 || // M6
      BS_sum > 1 || // M7
      (BS_sum >= 1 && BP_sum >= 3) || // M8
      (BP_sum > 2 && BP7 === 1) || // M10-1
      (BS_sum === 1 && BP_sum === 2 && BP7 === 1) // M10-2
    ) {
      return BPS[2] // Benign x
    }

    if (
      (PVS_sum === 1 && PS_sum > 0) || // F7
      (PVS_sum === 1 && PM_sum > 1) || // F8
      (PVS_sum === 1 && PM_sum > 0 && PP_sum > 0) || // F9
      (PVS_sum === 1 && PP_sum > 1) || // F10
      PS_sum > 1 || // F11
      (PS_sum > 0 && PM_sum > 2) || // F13
      (PS_sum > 0 && PM_sum > 1 && PP_sum > 1) || // F14
      (PS_sum > 0 && PM_sum > 0 && PP_sum > 3) // F15
    ) {
      return BPS[0] // Pathogenic
    }

    if (
      (PVS_sum === 1 && PM_sum === 1) || // I6
      (PS_sum === 1 && PM_sum < 3 && PM_sum >= 1) || // I8
      (PS_sum === 1 && PP_sum >= 2) || // I9
      PM_sum > 2 || // I10
      (PM_sum > 1 && PP_sum > 1) || // I11
      (PM_sum > 0 && PP_sum > 3) // I12
    ) {
      return BPS[1] // Likely pathogenic
    }

    if (
      ((BP7 === 0 || BP_sum < 3) &&
        BA1 === 0 &&
        BS_sum <= 1 &&
        BS1 === 1 &&
        BS_sum >= 1 &&
        BS_sum < 3) || // P6
      (BA1 === 0 &&
        BS_sum <= 1 &&
        (BS_sum === 0 || BP_sum < 3) &&
        (BP_sum <= 2 || BP7 === 0) &&
        (BS_sum !== 1 || BP_sum !== 2 || BP7 === 0) &&
        BS_sum === 1 &&
        BP_sum >= 1 &&
        BP_sum < 3) || // P7
      (BA1 === 0 &&
        BS_sum <= 1 &&
        (BS_sum === 0 || BP_sum < 3) &&
        (BP_sum <= 2 || BP7 === 0) &&
        (BS_sum !== 1 || BP_sum !== 2 || BP7 === 0) &&
        BP_sum >= 2) // P8
    ) {
      return BPS[3] // Likely benign
    }

    return BPS[4] // Uncertain significance
  }

  const acmgColor = (name: string) => {
    const k = (name || '').toUpperCase()
    if (k.startsWith('PVS') || k.startsWith('PS')) return 'rgba(229,38,35,0.85)'
    if (k.startsWith('PM')) return 'rgb(221,109,32)'
    if (k.startsWith('PP')) return 'rgb(93,181,249)'
    if (k.startsWith('BS') || k.startsWith('BP')) return 'rgba(46,125,50,0.75)'
    return 'rgba(103,142,197,0.7)'
  }

  // 评级 包括评分值以及下面描述rating description

  React.useEffect(() => {
    left.forEach((items) => {
      if (typeof items === 'object') {
        Object.getOwnPropertyNames(items).map((key) => {
          const item = items[key as unknown as 'benStrong1']
          const itemKey = item.title?.split('-')[0]

          const flag = checkedList?.find(
            (i) =>
              i === item.title ||
              i === item.key ||
              i.includes(item.key as any) ||
              i.includes(itemKey as any) ||
              item.key?.includes(i)
          )

          if (flag) {
            item.checked = true

            item.title = `${flag?.split('_')[0]}${
              judgeStrength(flag) ? `-${judgeStrength(flag)}` : ''
            }`

            item.key = flag
          } else if (typeof item === 'object') {
            item.checked = false
          }
        })
      }
    })

    const obj: ClassifyACMG = {
      PVS1: 0,
      PS: [0, 0, 0, 0, 0, 0],
      PM: [0, 0, 0, 0, 0, 0, 0, 0],
      PP: [0, 0, 0, 0, 0, 0, 0],
      BA1: 0,
      BS: [0, 0, 0, 0, 0],
      BP: [0, 0, 0, 0, 0, 0, 0]
    }
    const evd: NObject = {
      // PVS1
      PVS1: 0,

      // PS
      PS1: 0,
      PS2: 0,
      PS3: 0,
      PS4: 0,
      PVS1_Strong: 0,
      PP3_Strong: 0,

      // PM
      PM1: 0,
      PM2: 0,
      PM3: 0,
      PM4: 0,
      PM5: 0,
      PM6: 0,
      PVS1_Moderate: 0,
      PP3_Moderate: 0,

      // PP
      PP1: 0,
      PP2: 0,
      PP3: 0,
      PP4: 0,
      PP5: 0,
      PVS1_Supporting: 0,
      PM2_Supporting: 0,

      // BA1
      BA1: 0,

      // BS
      BS1: 0,
      BS2: 0,
      BS3: 0,
      BS4: 0,
      BP4_Strong: 0,

      // BP
      BP1: 0,
      BP2: 0,
      BP3: 0,
      BP4: 0,
      BP5: 0,
      BP6: 0,
      BP7: 0,

      // # PVS
      PM3_VeryStrong: 0,
      PS2_VeryStrong: 0
    }

    checkedList.map((item) => {
      const flag = Object.keys(evd).some((key) => key === item)

      if (flag) {
        evd[item] = 1
      } else {
        const newItem = item.split('_')[0]

        evd[newItem] = 1
      }
    })

    // List of evidences
    const PVS1 = evd['PVS1']
    const PS = [
      evd['PS1'],
      evd['PS2'],
      evd['PS3'],
      evd['PS4'],
      evd['PVS1_Strong'],
      evd['PP3_Strong']
    ]
    const PM = [
      evd['PM1'],
      evd['PM2'],
      evd['PM3'],
      evd['PM4'],
      evd['PM5'],
      evd['PM6'],
      evd['PVS1_Moderate'],
      evd['PP3_Moderate']
    ]
    const PP = [
      evd['PP1'],
      evd['PP2'],
      evd['PP3'],
      evd['PP4'],
      evd['PP5'],
      evd['PVS1_Supporting'],
      evd['PM2_Supporting']
    ]
    const BA1 = evd['BA1']
    const BS = [
      evd['BS1'],
      evd['BS2'],
      evd['BS3'],
      evd['BS4'],
      evd['BP4_Strong']
    ]
    const BP = [
      evd['BP1'],
      evd['BP2'],
      evd['BP3'],
      evd['BP4'],
      evd['BP5'],
      evd['BP6'],
      evd['BP7']
    ]

    const PVS = [evd['PM3_VeryStrong'], evd['PS2_VeryStrong']]

    // const cls = classifyV2(PVS1, PS, PM, PP, BA1, BS, BP, PVS)

    const newCls = classify(checkedList)

    // const classACMG = classifyACMG(
    //   obj.PVS1,
    //   obj.PS,
    //   obj.PM,
    //   obj.PP,
    //   obj.BA1,
    //   obj.BS,
    //   obj.BP
    // )

    const temp = marks.find((item) => item.key === newCls)

    console.log(
      'temp123',
      checkedList,
      temp,
      [PVS1, PS, PM, PP, BA1, BS, BP],

      // cls,
      newCls
    )

    if (temp) {
      setDescription({
        color: temp.color,
        label: temp.label
      })
    }
    let score = 0

    left.map((item: NObject) => {
      Object.keys(item).map((key) => {
        const temp = item[key]

        checkedList.map((i) => {
          const arr = i.split('_')
          const iTitle = arr[0]
          const iStrength = arr[1] ?? ''

          if (iStrength && (i === temp.key || i === temp.title)) {
            const value = strengthValue.find((j) => j.title === iStrength)

            if (value && value.value) {
              if (iTitle.includes('B')) {
                score += -value.value
              } else {
                score += value.value
              }
            }
          } else {
            if (i === temp.key || i === temp.title) {
              score += temp.score
            }
          }
        })
      })
    })

    marks.map((items) => {
      if (score >= items.min && score <= items.max) {
        if (items.key === 'Uncertain significance') {
          const pathogenicRating = items.pathogenicRating as any[]
          const temp = pathogenicRating.find((i: any) => i.key === score)

          if (temp) {
            setPathogenicRating(`${temp.value}`)
          }
        } else {
          setPathogenicRating(`${items.pathogenicRating[0]}`)
        }

        setSliderValue(items.value)
      }
    })

    setScore(score)

    setLeftData(left)
  }, [checkedList])

  React.useEffect(() => {
    let data = checkedList
      .map((item) => {
        return left
          .map((items) => {
            return Object.getOwnPropertyNames(items)
              .map((key) => {
                const temp = items[key as unknown as 'benStrong1']

                if (
                  temp &&
                  (temp.key === item ||
                    temp.title === item ||
                    item.includes(temp.key as any) ||
                    temp.key?.includes(item as any))
                ) {
                  //

                  return temp
                }
              })
              .flat()
              .filter((i) => i)
          })
          .flat()
      })
      .flat()
      .filter((i) => i)
      .map((item, index) => {
        return {
          id: index + 1,
          ...item,
          _id: '',
          object: {},
          user: {}
        }
      })

    //

    if (userAcmgData && userAcmgData.length) {
      data.map((items) => {
        const temp = userAcmgData.find(
          (item) =>
            item.acmgCriteria?.split('-')[0] === items?.title?.split('-')[0]
        )

        if (temp && temp.evidenceDetails && temp.variantId) {
          items.description = temp.evidenceDetails

          items._id = temp.variantId

          items.object = temp

          items.user = temp.user ?? {}
        }

        return items
      })
    }

    if (
      props.value.ClinGen_classification_data &&
      props.value.ClinGen_classification_data?.panel &&
      props.value.ClinGen_classification_data?.panel?.met_criteria
    ) {
      const arr =
        props.value.ClinGen_classification_data?.panel?.met_criteria.map(
          (i: any, index: number) => {
            return {
              level: '',
              score: '',
              title: i.code,
              description: i.summary,
              id: index + 1
            }
          }
        )

      data = [...arr]

      setMetCriteria(data)

      // setEvidenceSummary(props.value.ClinGen_classification_data?.panel?.evidence_summary)
    }

    setTableData(data)
  }, [checkedList, userAcmgData, props.value.ClinGen_classification_data])

  const genebeEveScore = React.useMemo(() => {
    const arr = genebeEve.split(',')

    //

    const data = leftData
      .map((items: any) => {
        return Object.keys(items)
          .map((key) => {
            const item = items[key]

            if (typeof item === 'object') {
              return {
                title: item.title,
                key: item.key,
                score: item.score,
                color: item.color
              }
            }
          })
          .filter((item) => item)
      })
      .flat()

    const value = arr.map((item) => {
      const first = splitAndFormat(item)[0]
      const second = splitAndFormat(item)[1]

      //

      const temp = data.find(
        (i) => i?.key?.includes(first) || i?.title?.includes(first)
      )

      //

      if (temp && temp.score) {
        if (second) {
          const value = strengthValue.find((j) => j.title === second)

          //

          if (value) {
            if (first.includes('B'))
              return {
                score: -value.value,
                key: first,
                strengthValue: second
              }
            else
              return {
                score: value.value,
                key: first,
                strengthValue: second
              }
          } else {
            return {
              score: temp.score,
              key: first,
              strengthValue: second
            }
          }
        }

        return {
          score: temp.score,
          key: first,
          strengthValue: second
        }
      }

      return {
        score: 0,
        key: first,
        strengthValue: second
      }
    })

    const up: any[] = []
    const down: any[] = []

    value.map((item) => {
      if (item.score < 0) {
        down.push(item)
      } else if (item.score > 0) {
        up.push(item)
      }
    })

    return {
      up,
      down
    }
  }, [genebeEve, leftData])

  const reset = () => {
    setCheckoutList(acmgValue.map((i) => i.key))
  }

  const scrollToSection = (ref: React.MutableRefObject<any>) => {
    console.log('current', ref.current)
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth', // 平滑滚动

        block: 'start' // 对齐到目标元素的顶部
      })
    }
  }

  const handdlACMGAIClick = async () => {
    if (
      variantsArticles &&
      variantsArticles.details &&
      variantsArticles.details[0]
    ) {
      return
    }

    const variantsParams = {
      assembly: props.analysisInfo.genomeBuild,
      variant: `${props.value.chrom}-${props.value.pos}-${
        props.value.REF ?? props.value.ref
      }-${props.value.ALT ?? props.value.alt}`,
      gene_name: props.value.gene
    }

    if (variantsParams.assembly) {
      getVarArticle.mutateAsync(variantsParams)
      const userParams: UserACMGLogs = {
        type,
        objectId: id as any,
        variantKey: `${props.value.gene}-${
          props.value?.c_nomen ?? props.value?.hgvsp
        }-${props.value.transcript ?? props.value.feature}`
      }
      const data = await getAllUserACMGLogs.mutateAsync(userParams)

      if (data && data.list) {
        setAllUserAcmgData(
          data.list.map((item: any) => {
            return {
              ...item,
              username: item && item.user ? item.user.username : ''
            }
          })
        )

        setAllUserAcmgCount(data.count)
      }
    }
  }

  const getgetUserACMGLogsFn = async () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')

    const userParams: UserACMGLogs = {
      type,
      objectId: id as any,
      variantKey: `${props.value.gene}-${
        props.value?.c_nomen ?? props.value?.hgvsp
      }-${props.value.transcript ?? props.value.feature}`
    }

    getUserACMGLogs.mutateAsync(userParams)
  }

  React.useEffect(() => {
    if (ability && ability.can('read', 'report-search')) {
      getHistoryReportsResultsFn()
    }
  }, [props.value])

  const currentTempHistory = React.useMemo(() => {
    if (
      props.value &&
      props.value.tempHistory &&
      Array.isArray(props.value.tempHistory) &&
      props.value.tempHistory.length
    ) {
      return props.value.tempHistory[0]
    } else return null
  }, [props.value])

  const getHistoryReportsResultsFn = () => {
    if (props.value && props.value.tempHistory) {
      setVariantsData(props.value.tempHistory)

      setVariantsCount(props.value.tempHistory.length)
    }

    const variantsParams = {
      pageSize: 1000,
      pageNum: 1,

      // setIn: [`${props.value.c_nomen} ${props.value.p_nomen}`],
      geneNameIn: [props.value.gene],
      chromosomePosition: `${props.value.chrom}:${props.value.pos}`

      // transcript: props.value.transcript ?? props.value.feature
    }

    // fetchHistoryReportsResults.mutateAsync(variantsParams)
  }

  const getVarGenebeArticleFn = async () => {
    const params = {
      chr: `${props.value.chrom}`,
      pos: `${props.value.pos}`,
      ref: props.value.REF ?? props.value.ref,
      alt: props.value.ALT ?? props.value.alt,
      genome: props.analysisInfo.genomeBuild
    }
    if (params.pos && params.genome) getVarGenebeArticle.mutateAsync(params)
  }

  const handleClickLeft = (index: number, key: any) => {
    //
    setSelectedIndex(index)

    if (key === 'acmg') {
      scrollToSection(AcmgTableref)
    } else if (key === 'comment') {
      scrollToSection(Commentref)
    } else if (key === 'other') {
      scrollToSection(Otherref)
    } else if (key === 'Publication') {
      scrollToSection(Publicationref)
    }
  }

  React.useEffect(() => {
    getgetUserACMGLogsFn()

    getVarGenebeArticleFn()
  }, [])

  React.useEffect(() => {
    handdlACMGAIClick()
  }, [])

  const createUserACMGLogByLists = async () => {
    // create
    const user = JSON.parse(localStorage.getItem('user') || '{}')

    const list = tableData.map((params) => {
      const createParams: UserACMGLogs = {
        userId: user.id,
        objectId: id as any,
        variantId: props.value.AnnotSV_ID
          ? props.value.AnnotSV_ID
          : props.value._id,
        type: type,
        acmgCriteria: params.title,
        evidenceDetails: params.description,
        createTime: new Date(),
        variantKey: `${props.value.gene}-${
          props.value?.c_nomen ?? props.value?.hgvsp
        }-${props.value.transcript ?? props.value.feature}`
      }

      return createParams
    })

    createUserACMGLogByList.mutateAsync({
      list
    })
  }

  const historyAcmgData = React.useMemo(() => {
    if (variantsData && variantsData.length) {
      const data = variantsData
        .map((row) => {
          if (row.evidenceItems) {
            const arr = row.evidenceItems.split('+')

            return arr
              .map((item) => {
                const first = item.split('_')[0]
                const text =
                  i18n.language !== 'zh'
                    ? ACMG_evidences_en[first]
                    : ACMG_evidences_zh[first]

                return {
                  id: null,
                  userId: null,
                  objectId: null,
                  variantId: null,
                  variantKey: row.variantInfo,
                  acmgCriteria: item,
                  evidenceDetails: `${first}:${text}`,
                  type: null,
                  createTime: row.createdAt,
                  username: `历史报告(${row?.historyReportsPatient?.sampleId})`
                }
              })
              .map((item: any, index: number) => {
                return {
                  ...item,
                  id: index + 1
                }
              })
          }

          return []
        })
        .flat()

      return data
    }

    return []
  }, [variantsData])

  React.useEffect(() => {
    if (props.value) {
      const value = props.value
      const rsId =
        value.rs_id ||
        (value.rsid && Array.isArray(value.rsid) ? value.rsid[0] : '')

      const clinvarId = value.clinvar_id
        ? value.clinvar_id
        : value.CLINVAR_variant_id && value.CLINVAR_variant_id !== '.'
        ? `${value.CLINVAR_variant_id}`
        : ''
      const clinvarIds = value.clinvar_ids
      const params = {
        gene: value.gene,
        rsId: rsId,
        pnomen: value.p_nomen ?? value.hgvsc,
        cnomen: value.c_nomen ?? value.hgvsp,
        pubmed: `${value.pubmed}`,
        omimPubmed: value.OMIM?.pubmedIds
      }
      if (value.MitoMap) {
        params.omimPubmed = value.MitoMap.pubmed_ids
      }
      if (
        value.pubmed_ids &&
        Array.isArray(value.pubmed_ids) &&
        value.pubmed_ids.length
      ) {
        params.omimPubmed = value.pubmed_ids.join(',')
      }
      if (params.omimPubmed) {
        // Articles.mutateAsync(params)

        GoogleArticle.mutateAsync(params)
      }
      if (clinvarId && clinvarId !== '.') {
        //
        getClinvarArticlesFn(clinvarId)
      }

      // if (clinvarIds && clinvarIds !== '.' && clinvarIds.length) {
      //   getClinvarArticlesFn(clinvarIds)
      // }

      if (rsId && rsId !== '.')
        getLitVarArticle.mutateAsync({
          rsId: rsId,
          litPage
        })
    }
  }, [props.value])

  const getClinvarArticlesFn = async (clinvarId: string | string[]) => {
    if (typeof clinvarId === 'string') {
      const data = await CitationsArticle.mutateAsync(clinvarId)
      setClinvarArticles(data || [])
    } else if (Array.isArray(clinvarId)) {
      const data = (
        await Promise.all(
          clinvarId.map(
            async (item) => await CitationsArticle.mutateAsync(item)
          )
        )
      ).flat()
      setClinvarArticles(data || [])
    }
  }

  const fetchHistoryReportsResults = useMutation({
    mutationFn: (data: HistoryReportsResults | Paginations) => {
      return getHistoryReportsrResults(data)
    },
    onSuccess: (data: { list: HistoryReportsResults[]; count: number }) => {
      if (data && Array.isArray(data.list)) {
        setVariantsData(data.list)

        setVariantsCount(data.count)

        //
      }
    }
  })

  const GoogleArticle = useMutation({
    mutationFn: async (data: GetArticlesDto) => await getGoogleArticles(data),
    onSuccess: (datas: any) => {
      //post返回的结果
      // setOMIM(datas)
      setScholarArticles(datas?.scholarArticles ?? [])
    }
  })

  const Articles = useMutation({
    mutationFn: async (data: GetArticlesDto) => await getArticles(data),
    onSuccess: (datas: any) => {
      //post返回的结果
      setVariantPubmedArticles(datas?.genePubmedArticles ?? [])
    }
  })

  const getLitVarArticle = useMutation({
    mutationFn: async (params: { rsId: string; litPage: number }) =>
      await getLitVarArticles(params.rsId, params.litPage),
    onSuccess: (datas: any) => {
      //post返回的结果

      setLitVarArticles(datas)
    }
  })
  const CitationsArticle = useMutation({
    mutationFn: async (pubmedId: string) =>
      await getCitationsByVariation({
        id: pubmedId
      }),
    onSuccess: (datas: any) => {
      //post返回的结果
      // setClinvarArticles(datas || [])
    }
  })

  const getVarArticle = useMutation({
    mutationFn: async (params: GetVariantLiteratureDto) =>
      await getVarDetail(params),
    onSuccess: (datas: any) => {
      //post返回的结果
      if (datas && datas.details && datas.details[0]) {
        setVariantsArticles(datas)

        setAcmg(
          datas.details[0]?.acmg
            ?.filter((item: any) => item.code_status)
            .map((item: any) => {
              if (item.code_name === 'PM2') {
                item.code_strength = `supporting`
              }
              if (item.code_name === 'PP3') {
                const revel = extractMetricValue(item.evidence, 'REVEL')
                if (revel) {
                  if (revel >= 0.644 && revel <= 0.773) {
                    item.code_strength = `supporting`
                  } else if (revel >= 0.644 && revel <= 0.932) {
                    item.code_strength = `moderate`
                  } else if (revel >= 0.932) {
                    item.code_strength = `strong`
                  }
                }
              }

              return `${item.code_name}//${item.code_strength ?? ''}//${
                item.evidence
              }`
            })
        )

        setsummarization(
          datas.details[0]?.pubmed_articles?.summarization?.split(
            '- Comment(s) from Clinvar:'
          )[0]
        )

        setComment(
          datas.details[0]?.pubmed_articles?.summarization?.split(
            '- Comment(s) from Clinvar:\n'
          )[1]
        )
      }
    }
  })

  const getVarGenebeArticle = useMutation({
    mutationFn: async (params: VariantDto) =>
      await getVarGenebeArticles(params),
    onSuccess: (datas: any) => {
      //post返回的结果
      if (datas && datas.variants && datas.variants.length) {
        setGenebe(datas.variants)

        setGenebeEve(datas.variants[0].acmg_criteria)
      }
    }
  })

  const Translate = useMutation({
    mutationFn: async (data: TranslateDto) => await translate(data),
    onSuccess: (data, params, context) => {
      //post返回的结果
      // setTranslates(data)
    }
  })

  const getUserACMGLogs = useMutation({
    mutationFn: async (data: UserACMGLogs) => await fetchUserACMGLogs(data),
    onSuccess: (data, params, context) => {
      //post返回的结果
      // setTranslates(data)
      if (data && data.list) {
        setUserAcmgData(
          data.list.map((item: any) => {
            return {
              ...item,
              username: item && item.user ? item.user.username : ''
            }
          })
        )

        setUserAcmgCount(data.count)
      }
    }
  })

  const getAllUserACMGLogs = useMutation({
    mutationFn: async (data: UserACMGLogs) => await fetchUserACMGLogs(data)

    // onSuccess: (data, params, context) => {
    //   //post返回的结果
    //   // setTranslates(data)
    //   if (data && data.list) {
    //     setAllUserAcmgData(data.list)

    //     setAllUserAcmgCount(data.count)

    //     setLogsOpen(true)
    //   }
    // }
  })

  const createUserACMGLog = useMutation({
    mutationFn: async (data: UserACMGLogs) => await createUserACMGLogs(data),
    onSuccess: (data, params, context) => {
      //post返回的结果
    }
  })

  const createUserACMGLogByList = useMutation({
    mutationFn: async (data: { list: UserACMGLogs[] }) =>
      await createUserACMGLogsByList(data),
    onSuccess: (data, params, context) => {
      //post返回的结果

      getgetUserACMGLogsFn()
    }
  })

  const updateUserACMGLog = useMutation({
    mutationFn: async (data: UserACMGLogs) => await updateUserACMGLogs(data),
    onSuccess: (data, params, context) => {
      //post返回的结果
    }
  })

  const tableData1 = React.useMemo(() => {
    return NameGroupingComponent(
      unique(
        [...userAcmgData, ...historyAcmgData].map((items) => {
          return {
            ...items,
            keyId: `${items.userId}-${items.acmgCriteria}-${items.evidenceDetails}`
          }
        }),
        'keyId'
      )
        .map((item: any, index: number) => {
          return {
            ...item,
            id: index + 1
          }
        })
        .slice(0, 5)
    )
  }, [userAcmgData, historyAcmgData])

  const tableData2 = React.useMemo(() => {
    return NameGroupingComponent(
      unique(
        [...allUserAcmgData].map((items) => {
          return {
            ...items,
            keyId: `${items.userId}-${items.acmgCriteria}-${items.evidenceDetails}`
          }
        }),
        'keyId'
      )
    )
  }, [allUserAcmgData])

  React.useImperativeHandle(ref, () => {
    return {
      reset,
      checkedList,
      description,
      createUserACMGLogByLists,
      handleClickLeft
    }
  })

  return (
    <Box>
      {contextHolder}
      <Grid container>
        {isWindow() && (
          <>
            <Grid item xs={1.5} position={'sticky'} top={0} height={'100%'}>
              <List component="div">
                {leftDataValue.map((item, index) => {
                  return (
                    <ListItemStyled
                      sx={{
                        borderLeftColor:
                          index === selectedIndex
                            ? 'primary.main'
                            : 'transparent',
                        cursor: 'pointer'
                      }}
                      key={item.title}
                      onClick={() => {
                        handleClickLeft(index, item.key)
                      }}
                    >
                      <ListItemText
                        primary={item.title}
                        primaryTypographyProps={{
                          noWrap: true,
                          sx: {
                            fontWeight: 500,
                            ...(index === selectedIndex && {
                              color: 'primary.main'
                            })
                          }
                        }}
                      />
                    </ListItemStyled>
                  )
                })}
              </List>
            </Grid>

            <Divider orientation="vertical" flexItem />
          </>
        )}
        <Grid item xs={isWindow() ? 10.4 : 12}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Stack direction={'column'}>
                <TableContainer ref={AcmgTableref} component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>

                        <TableCell colSpan={12}>
                          <ACMGSlider
                            value={sliderValue}
                            title={t('Bayesian algorithm rating')}
                            key={sliderValue}
                            score={score}
                            pathogenicRating={pathogenicRating}
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {leftData.map((row) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            '&:last-of-type td, &:last-of-type th': {
                              border: 0
                            }
                          }}
                        >
                          <TableCell
                            sx={{
                              padding: 0,
                              paddingTop: '5px !important',
                              paddingBottom: '5px !important',
                              fontWeight: rightData.find(
                                (item) => item.title === row.name
                              )
                                ? 'bold'
                                : '500',
                              cursor: rightData.find(
                                (item) => item.title === row.name
                              )
                                ? 'pointer'
                                : 'auto'
                            }}
                            component="th"
                            scope="row"
                            onClick={() => {
                              const container =
                                document.getElementById('scroll')

                              const index = rightData.findIndex(
                                (item) => item.title === row.name
                              )

                              let height = 0

                              for (let i = 0; i < index; i++) {
                                height += document.getElementById(`${i}`)
                                  ?.scrollHeight as number
                              }

                              container?.scrollTo({
                                top: height,
                                behavior: 'smooth'
                              })
                            }}
                          >
                            {row.name}
                          </TableCell>

                          {Object.getOwnPropertyNames(row).map((key, index) => {
                            const item = row[key as unknown as 'benStrong1']
                            if (key === 'name') return null
                            const strengthArr = item.title?.split('-')
                            let strength = ''

                            if (strengthArr && strengthArr.length > 1) {
                              strength = strengthArr[1]
                            }

                            return (
                              <TableCell
                                sx={{
                                  padding: 0,
                                  paddingTop: '5px !important',
                                  paddingBottom: '5px !important'
                                }}
                                key={index}
                              >
                                <ChipBox
                                  title={item?.title}
                                  checked={item?.checked}
                                  description={
                                    item.description ? item.description : ''
                                  }
                                  fn={(value: boolean, title: string) => {
                                    //BS2 PM2
                                    //BP3 PM4
                                    //BP2 PM3

                                    const strengthArr = title?.split('-')
                                    let key = title

                                    if (
                                      strengthArr &&
                                      strengthArr.length &&
                                      strengthArr.length > 1
                                    ) {
                                      const value = strengthArr[1]

                                      key = `${strengthArr[0]}_${
                                        value === 'S'
                                          ? 'Strong'
                                          : value === 'VS'
                                          ? 'VeryStrong'
                                          : value === 'M'
                                          ? 'Moderate'
                                          : value === 'P'
                                          ? 'Supporting'
                                          : ''
                                      }`
                                    }

                                    if (value) {
                                      const data = [...checkedList, key]

                                      setCheckoutList(data)
                                    } else
                                      setCheckoutList(
                                        [...checkedList].filter(
                                          (item) => item !== key
                                        )
                                      )

                                    // 评级
                                    //意义未明 良性 可能良性 可能致病性 致病性
                                    // setSliderValue(Math.random() * 100)
                                  }}
                                  color={item.color}
                                  close={item.close}
                                  strength={strength}
                                  changeStrength={(value: string) => {
                                    if (item.title) {
                                      const strengthArr = item.title?.split('-')
                                      const newData = _.cloneDeep(leftData).map(
                                        (items: any) => {
                                          Object.keys(items).map((key) => {
                                            const temp = items[key]

                                            if (temp.key === item.key) {
                                              temp.title = `${strengthArr[0]}-${value}`

                                              temp.key = `${strengthArr[0]}_${
                                                value === 'S'
                                                  ? 'Strong'
                                                  : value === 'VS'
                                                  ? 'VeryStrong'
                                                  : value === 'M'
                                                  ? 'Moderate'
                                                  : value === 'P'
                                                  ? 'Supporting'
                                                  : ''
                                              }`
                                            }
                                          })

                                          return items
                                        }
                                      )

                                      left.forEach((items) => {
                                        if (typeof items === 'object') {
                                          Object.getOwnPropertyNames(items).map(
                                            (key) => {
                                              const temp =
                                                items[
                                                  key as unknown as 'benStrong1'
                                                ]

                                              if (temp.key === item.key) {
                                                temp.title = `${strengthArr[0]}-${value}`

                                                temp.key = `${strengthArr[0]}_${
                                                  value === 'S'
                                                    ? 'Strong'
                                                    : value === 'VS'
                                                    ? 'VeryStrong'
                                                    : value === 'M'
                                                    ? 'Moderate'
                                                    : value === 'P'
                                                    ? 'Supporting'
                                                    : ''
                                                }`
                                              }
                                            }
                                          )
                                        }
                                      })

                                      setCheckoutList(
                                        checkedList.map((i) => {
                                          if (i.includes(strengthArr[0])) {
                                            i = `${strengthArr[0]}_${
                                              value === 'S'
                                                ? 'Strong'
                                                : value === 'VS'
                                                ? 'VeryStrong'
                                                : value === 'M'
                                                ? 'Moderate'
                                                : value === 'P'
                                                ? 'Supporting'
                                                : ''
                                            }`
                                          }

                                          return i
                                        })
                                      )

                                      setLeftData(newData)
                                    }
                                  }}
                                />
                              </TableCell>
                            )
                          })}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Stack
                  alignItems={'center'}
                  border="1px solid"
                  borderRadius={'5px'}
                  padding="2px"
                  sx={{
                    color: '#fff',
                    bgcolor: description?.color
                  }}
                >
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography>
                          {i18n.language === 'zh'
                            ? `${t(description?.label as string)} 的分级依据`
                            : `The basis for grading ${description?.label}`}
                        </Typography>

                        {/* <List>
                        {textList.map((items) => {
                          return (
                            <ListItem key={items.title}>
                              <ListItemIcon>
                                <CircleSmall />
                              </ListItemIcon>

                              {items.title}
                            </ListItem>
                          )
                        })}
                      </List> */}
                      </React.Fragment>
                    }
                  >
                    <Typography
                      fontWeight={'bold'}
                      lineHeight="26px"
                      flexWrap={'wrap'}
                      textAlign="center"
                      width={'100%'}
                      overflow="auto"
                      paddingBottom={2}
                      sx={{
                        color: '#fff'
                      }}
                    >
                      {`ACMG:${description?.label}`}

                      <Typography
                        component={'span'}
                        sx={{
                          color: '#fff'
                        }}
                      >
                        {`${
                          !checkedList.length
                            ? ''
                            : `(${checkedList.join('+')})`
                        }`}
                      </Typography>
                    </Typography>
                  </HtmlTooltip>
                </Stack>

                {props.value.ClinGen_classification_data?.clinical
                  ?.classification ? (
                  <Stack
                    direction={'row'}
                    spacing={2}
                    justifyContent={'space-between'}
                    alignItems="center"
                  >
                    <Typography>
                      {t('ClinGen verdict is')}
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: '20px',
                          color:
                            ACMGClassification.find(
                              (item) =>
                                item.key ===
                                  props.value.ClinGen_classification_data
                                    ?.clinical?.classification ||
                                item.title ===
                                  props.value.ClinGen_classification_data
                                    ?.clinical?.classification
                            )?.color ?? 'rgba(229,38,35,0.8)'
                        }}
                      >
                        {` ${props.value.ClinGen_classification_data?.clinical?.classification}`}
                      </span>
                      .
                    </Typography>
                  </Stack>
                ) : (
                  ''
                )}

                {/* {props.value && props.value.AutoGVP_classification ? (
                  <Typography
                    sx={{
                      pt: 2
                    }}
                  >
                    {t(`AutoGVP Classification: `)}

                    <span
                      style={{
                        color: bgcolor ?? 'black',
                        fontWeight: 600
                      }}
                    >
                      {`${props.value.AutoGVP_classification.split(' ')
                        .map((word: string | string[]) => {
                          if (word.includes('Uncertain')) return `VU`
                          if (word.includes('null')) return ``
                          else return word[0].toUpperCase()
                        })
                        .join('')}`}
                    </span>
                  </Typography>
                ) : (
                  ''
                )} */}

                <Box ref={Commentref} mt={4}>
                  {props.value.ClinGen_classification_data?.panel
                    ?.evidence_summary ? (
                    <Stack
                      direction={'row'}
                      spacing={2}
                      justifyContent={'start'}
                      alignItems="center"
                    >
                      <Typography>{t('Cligen ACMG Evidence:')}</Typography>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={async () => {
                          messageApi.info(t('Please wait for a moment'))
                          const text =
                            props.value.ClinGen_classification_data?.panel
                              ?.evidence_summary

                          if (evidenceSummary) {
                            setEvidenceSummary('')
                            const arr =
                              props.value.ClinGen_classification_data?.panel?.met_criteria.map(
                                (i: any, index: number) => {
                                  return {
                                    level: '',
                                    score: '',
                                    title: i.code,
                                    description: i.summary,
                                    id: index + 1
                                  }
                                }
                              )

                            setMetCriteria(arr)

                            return
                          }
                          const sourceLanguage = 'en',
                            targetLanguage = 'zh'

                          const params1: TranslateDto = {
                            sourceText: text,
                            sourceLanguage,
                            targetLanguage
                          }

                          if (params1.sourceText) {
                            const data = await Translate.mutateAsync(params1)

                            setEvidenceSummary(data)
                          }

                          const datas = await Promise.all(
                            metCriteria.map(async (item) => {
                              const params: TranslateDto = {
                                sourceText: item.description,
                                sourceLanguage,
                                targetLanguage
                              }
                              const data = await Translate.mutateAsync(params)

                              return {
                                ...item,
                                description: data
                              }
                            })
                          )

                          setMetCriteria(datas)
                        }}
                      >
                        {t('translate')}
                      </Button>
                    </Stack>
                  ) : (
                    ''
                  )}
                  <Tables
                    rows={metCriteria.length ? metCriteria : tableData}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 99
                        }
                      }
                    }}
                    pageSizeOptions={[100]}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableVirtualization
                    rowCount={
                      metCriteria.length ? metCriteria.length : tableData.length
                    }
                    slots={null}
                    sx={{
                      '& .MuiDataGrid-footerContainer': {
                        justifyContent: 'center',
                        display: 'none'
                      },
                      '& .MuiDataGrid-columnHeaders': {
                        bgcolor: '#EDEFF0'
                      }
                    }}
                    processRowUpdate={(params: any) => {
                      //

                      setTableData(
                        tableData.map((items) => {
                          if (params.id === items.id) {
                            return params
                          } else return items
                        })
                      )
                    }}
                  />
                  {props.value.ClinGen_classification_data?.panel
                    ?.evidence_summary ? (
                    <>
                      <Typography>{'Cligen专家意见:'}</Typography>

                      <Typography>
                        {evidenceSummary
                          ? evidenceSummary
                          : props.value.ClinGen_classification_data?.panel
                              ?.evidence_summary}
                      </Typography>
                    </>
                  ) : (
                    ''
                  )}
                </Box>

                <Box textAlign="right">
                  <Stack direction={'row'} spacing={2}>
                    <Button
                      variant="contained"
                      onClick={async () => {
                        const userParams: UserACMGLogs = {
                          type,
                          objectId: id as any,
                          variantKey: `${props.value.gene}-${
                            props.value?.c_nomen ?? props.value?.hgvsp
                          }-${props.value.transcript ?? props.value.feature}`
                        }

                        const data = await getAllUserACMGLogs.mutateAsync(
                          userParams
                        )

                        if (data && data.list) {
                          if (variantsData && variantsData.length) {
                            const rowData = variantsData
                              .map((row) => {
                                if (row.evidenceItems) {
                                  const arr = row.evidenceItems.split('+')

                                  return arr.map((item) => {
                                    const first = item.split('_')[0]
                                    const text =
                                      i18n.language !== 'zh'
                                        ? ACMG_evidences_en[first]
                                        : ACMG_evidences_zh[first]

                                    return {
                                      id: null,
                                      userId: null,
                                      objectId: null,
                                      variantId: null,
                                      variantKey: row.variantInfo,
                                      acmgCriteria: item,
                                      evidenceDetails: `${first}:${text}`,
                                      type: null,
                                      createTime: row.createdAt,
                                      username: `历史报告(${row?.historyReportsPatient?.sampleId})`
                                    }
                                  })
                                }

                                return []
                              })
                              .flat()

                            const list = [
                              ...data.list.map((item: any) => {
                                return {
                                  ...item,
                                  username:
                                    item && item.user ? item.user.username : ''
                                }
                              }),
                              ...rowData
                            ].map((item: any, index: number) => {
                              return {
                                ...item,
                                id: index + 1
                              }
                            })

                            setAllUserAcmgData(list)

                            setAllUserAcmgCount(data.count + list.length)
                          } else {
                            const list = [
                              ...data.list.map((item: any) => {
                                return {
                                  ...item,
                                  username:
                                    item && item.user ? item.user.username : ''
                                }
                              })
                            ].map((item: any, index: number) => {
                              return {
                                ...item,
                                id: index + 1
                              }
                            })

                            setAllUserAcmgData(list)

                            setAllUserAcmgCount(data.count)
                          }

                          setLogsOpen(true)
                        }
                      }}
                    >
                      {t('Chain of evidence')}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={async () => {
                        await handdlACMGAIClick()

                        setTimeout(() => {
                          scrollToSection(Summaryref)
                        }, 500)
                      }}
                    >
                      GLS ACMG AI
                    </Button>
                  </Stack>
                </Box>
                <Box>
                  <Tables
                    rows={tableData1 as Item[]}
                    columns={columns3}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 99
                        }
                      }
                    }}
                    pageSizeOptions={[100]}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableVirtualization
                    rowCount={
                      [...userAcmgData, ...historyAcmgData].slice(0, 5).length
                    }
                    slots={null}
                    sx={{
                      '& .MuiDataGrid-footerContainer': {
                        justifyContent: 'center',
                        display: 'none'
                      },
                      '& .MuiDataGrid-columnHeaders': {
                        bgcolor: '#EDEFF0'
                      }
                    }}
                  />
                </Box>

                <Box>
                  <Typography>
                    {currentTempHistory
                      ? `${t('Historical data:')}${props.analysisInfo.name} ${t(
                          'Pathogenicity:'
                        )}${currentTempHistory.pathogenicityClassification}:${
                          currentTempHistory.evidenceItems
                        }，${t('Literature Association:')}${JSON.parse(
                          currentTempHistory.referenceSources
                        )?.join(';')}`
                      : t('Historical data: None')}
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                paddingRight: 3
              }}
            >
              {genebe && genebe[0] ? (
                <Stack
                  sx={{
                    cursor: 'pointer'
                  }}
                  spacing={2}
                  py={2}
                  onClick={() => {
                    window.open(
                      `https://genebe.net/variant/${
                        props.analysisInfo.genomeBuild
                      }/chr${props.value.chrom}-${props.value.pos}-${
                        props.value.REF ?? props.value.ref
                      }-${props.value.ALT ?? props.value.alt}`
                    )
                  }}
                >
                  <Typography>
                    {t('GeneBe verdict is')}
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: '20px',
                        color:
                          ACMGClassification.find(
                            (item) =>
                              item.key === genebe[0]?.acmg_classification ||
                              item.title === genebe[0]?.acmg_classification
                          )?.color ?? 'rgba(229,38,35,0.8)'
                      }}
                    >
                      {` ${genebe[0]?.acmg_classification}`}
                    </span>
                    .Variant got
                    <span
                      style={{
                        fontWeight: 700
                      }}
                    >
                      {` ${genebe[0]?.acmg_score} `}
                    </span>
                    ACMG points:
                    <span
                      style={{
                        color: 'rgb(249 ,115, 22)'
                      }}
                    >
                      {` ${genebeEveScore?.up?.reduce(
                        (accumulator, currentObject) => {
                          return accumulator + currentObject.score
                        },
                        0
                      )}P `}
                    </span>
                    and
                    <span
                      style={{
                        color: 'rgb(101 ,163 ,13)'
                      }}
                    >
                      {` ${genebeEveScore?.down?.reduce(
                        (accumulator, currentObject) => {
                          return accumulator + currentObject.score
                        },
                        0
                      )}B`}
                    </span>
                    .
                  </Typography>

                  <Stack direction={'row'} spacing={2}>
                    {genebe[0]?.acmg_criteria?.split(',').map((item: any) => {
                      return <Chip label={item} color={'error'} />
                    })}
                  </Stack>
                </Stack>
              ) : (
                ''
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                paddingRight: 3
              }}
              id="scroll"
            >
              <Box ref={Otherref}>
                {/* {variantsArticles?.details &&
                variantsArticles?.details[0]?.population_data.af_table ? (
                  <Index
                    columns={column as any}
                    rows={
                      variantsArticles?.details[0]?.population_data.af_table
                    }
                    maxHeight={500}
                  />
                ) : (
                  ''
                )} */}

                <Index
                  columns={column as any}
                  rows={rows}
                  maxHeight={500}
                  key={JSON.stringify(rows)}
                />

                <Box mt={4}>
                  {props.value ? (
                    <Index columns={columnCN as any} rows={[props.value]} />
                  ) : (
                    ''
                  )}
                </Box>
                <TableContainer
                  sx={{
                    mt: 4
                  }}
                >
                  <Table>
                    <TableBody>
                      {MAX_AF.map((item) => {
                        return (
                          <TableRow key={item?.key}>
                            <TableCell
                              sx={{
                                paddingBottom: '0 !important',
                                paddingTop: '0 !important',
                                paddingRight: '0 !important',
                                border: 'none'
                              }}
                            >
                              {item?.key}
                            </TableCell>

                            <TableCell
                              sx={{
                                textAlign: 'left',
                                paddingBottom: '0 !important',
                                paddingTop: '0 !important',
                                paddingRight: '0 !important',
                                border: 'none'
                              }}
                            >
                              {item.value}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{
                    minWidth: '100%',
                    width: 'max-content',
                    mt: 4
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            bgcolor: 'rgba(240,239,240)',
                            position: 'static',
                            fontSize: '12px',
                            padding: '4px 16px'
                          }}
                        >
                          {t('Tools')}
                        </TableCell>
                        <TableCell
                          sx={{
                            bgcolor: 'rgba(240,239,240)',
                            position: 'static',
                            fontSize: '12px',
                            padding: '4px 16px',
                            textAlign: 'right'
                          }}
                        >
                          {t('Score')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Prediction.map((item) => {
                        return (
                          <TableRow key={item?.key}>
                            <TableCell
                              sx={{
                                paddingBottom: '8px !important',
                                paddingTop: '8px !important',
                                paddingRight: 0
                              }}
                            >
                              {item?.key}
                            </TableCell>

                            <TableCell
                              sx={{
                                textAlign: 'right',
                                paddingBottom: '8px !important',
                                paddingTop: '8px !important',
                                paddingRight: 0
                              }}
                            >
                              {item?.value}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            <Grid item xs={12} id={'chpt_list'}>
              {props.analyzeVariants ? (
                <AnalyzeVariants
                  setAnalyzeVariant={props.setAnalyzeVariant}
                  setIsFinish={props.setIsFinish}
                  value={props.analyzeVariants}
                />
              ) : (
                ''
              )}
            </Grid>
            <Box ref={Summaryref} pl={6} pr={3} width={'100%'}>
              <Grid item xs={12}>
                {variantsArticles && variantsArticles.details ? (
                  <Card>
                    <CardContent
                      sx={{
                        maxWidth: '1200px'
                      }}
                    >
                      <Typography
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '0 2.25rem',
                          fontSize: '1.15rem'
                        }}
                        minHeight={50}
                        component={'h5'}
                      >
                        ACMG Classification and Evidence
                      </Typography>

                      <Divider />

                      <Box paddingLeft={'2.25rem'}>
                        {variantsArticles && variantsArticles.details ? (
                          <React.Fragment>
                            <Stack direction={'row'} spacing={2}>
                              <Typography fontSize={18} color="#237aaa" py={1}>
                                {' GLS AI ACMG Classification:'}
                              </Typography>

                              <Box
                                sx={{
                                  p: 2,
                                  color: 'white',
                                  backgroundColor:
                                    ACMGClassification.find(
                                      (item) =>
                                        item.key ===
                                          variantsArticles.details[0]
                                            ?.acmg_classification ||
                                        item.title ===
                                          variantsArticles.details[0]
                                            ?.acmg_classification
                                    )?.color ?? 'rgba(229,38,35,0.8)',
                                  borderRadius: '5px'
                                }}
                              >
                                {
                                  variantsArticles.details[0]
                                    ?.acmg_classification
                                }
                              </Box>
                            </Stack>

                            {acmg && acmg.length
                              ? acmg.map((item: string, idx) => {
                                  const arr = item.split('//')
                                  const key = arr[0]
                                  const code_strength = arr[1]
                                  const evidence = arr[2]

                                  return (
                                    <Box
                                      key={`${key}-${idx}`}
                                      sx={{
                                        p: 1.5,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 2
                                      }}
                                    >
                                      <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                        sx={{ mb: 0.5 }}
                                      >
                                        <Stack direction="row" spacing={0.5}>
                                          <Chip
                                            label={key}
                                            size="small"
                                            sx={{
                                              height: 22,
                                              bgcolor: acmgColor(key),
                                              color: '#fff',
                                              textDecoration:
                                                key === 'PP5'
                                                  ? 'line-through'
                                                  : 'none',
                                              textDecorationColor: 'black'
                                            }}
                                          />
                                          {code_strength ? (
                                            <Typography
                                              sx={{
                                                fontSize: 12,
                                                color: 'text.secondary',
                                                textDecoration:
                                                  key === 'PP5'
                                                    ? 'line-through'
                                                    : 'none'
                                              }}
                                            >
                                              {code_strength}
                                            </Typography>
                                          ) : null}

                                          {key === 'PP5' ? (
                                            <Typography
                                              sx={{
                                                fontSize: 14,
                                                color: 'red'
                                              }}
                                            >
                                              该证据不适用
                                            </Typography>
                                          ) : null}

                                          {key === 'PP1' ? (
                                            <Typography
                                              sx={{
                                                fontSize: 14,
                                                color: 'red'
                                              }}
                                            >
                                              优化中，建议复核证据强度
                                            </Typography>
                                          ) : null}
                                        </Stack>
                                      </Stack>
                                      <Typography sx={{ fontSize: 14 }}>
                                        {evidence || 'N/A'}
                                      </Typography>
                                    </Box>
                                  )
                                })
                              : ''}

                            <Stack
                              direction={'row'}
                              justifyContent="end"
                              py={2}
                            >
                              <Box display={'flex'} alignItems="center">
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={async () => {
                                    if (translates) {
                                      setAcmg(
                                        variantsArticles.details[0]?.acmg
                                          ?.filter(
                                            (item: any) => item.code_status
                                          )
                                          .map(
                                            (item: any) =>
                                              `${item.code_name}//${
                                                item.code_strength ?? ''
                                              }//${item.evidence}`
                                          )
                                      )

                                      setComment(
                                        variantsArticles.details[0]?.pubmed_articles?.summarization?.split(
                                          '- Comment(s) from Clinvar:\n'
                                        )[1]
                                      )

                                      setsummarization(
                                        variantsArticles.details[0]?.pubmed_articles?.summarization?.split(
                                          '- Comment(s) from Clinvar:'
                                        )[0]
                                      )

                                      return setTranslates('')
                                    }
                                    const sourceLanguage = 'en',
                                      targetLanguage = 'zh'

                                    const params1: TranslateDto = {
                                      sourceText: Comment,
                                      sourceLanguage,
                                      targetLanguage
                                    }

                                    if (params1.sourceText) {
                                      const data = await Translate.mutateAsync(
                                        params1
                                      )

                                      setComment(data)
                                    }

                                    const params2: TranslateDto = {
                                      sourceText: summarization,
                                      sourceLanguage,
                                      targetLanguage
                                    }

                                    if (params2.sourceText) {
                                      const data = await Translate.mutateAsync(
                                        params2
                                      )

                                      setsummarization(data)
                                    }

                                    setTranslates('1')

                                    const datas = await Promise.all(
                                      acmg.map(async (item) => {
                                        const params: TranslateDto = {
                                          sourceText: item,
                                          sourceLanguage,
                                          targetLanguage
                                        }

                                        return await Translate.mutateAsync(
                                          params
                                        )
                                      })
                                    )

                                    setAcmg(datas)
                                  }}
                                >
                                  {t('translate')}
                                </Button>
                              </Box>
                            </Stack>
                          </React.Fragment>
                        ) : (
                          <Typography paddingLeft={'2.25rem'}>
                            No ACMG Classification and Evidence
                          </Typography>
                        )}
                      </Box>

                      {/* <Stack>
                        <Typography>
                          {t('GLS user pathogenicity rating')}
                        </Typography>

                        <Box>
                          <Tables
                            rows={allUserAcmgData as Item[]}
                            columns={columns3}
                            initialState={{
                              pagination: {
                                paginationModel: {
                                  pageSize: 99
                                }
                              }
                            }}
                            pageSizeOptions={[100]}
                            checkboxSelection={false}
                            disableRowSelectionOnClick
                            disableColumnMenu
                            disableVirtualization
                            rowCount={allUserAcmgCount}
                            slots={null}
                            sx={{
                              '& .MuiDataGrid-footerContainer': {
                                justifyContent: 'center',
                                display: 'none'
                              },
                              '& .MuiDataGrid-columnHeaders': {
                                bgcolor: '#EDEFF0'
                              }
                            }}
                          />
                        </Box>
                      </Stack> */}
                    </CardContent>
                  </Card>
                ) : (
                  ''
                )}

                <Card ref={Publicationref}>
                  <CardContent>
                    <Tabs
                      value={tabValueArticle}
                      onChange={(e, value) => setTabValueArticle(value)}
                      aria-label="basic tabs example"
                      sx={{
                        position: 'relative'
                      }}
                    >
                      {variantsArticles && variantsArticles.details ? (
                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`PubMed Articles (${
                            variantsArticles && variantsArticles.details
                              ? variantsArticles.details[0]?.pubmed_articles
                                  ?.literatures?.length
                              : 0
                          })`}
                          {...a11yProps(0)}
                        />
                      ) : (
                        ''
                      )}

                      <Tab
                        sx={{
                          textTransform: 'capitalize'
                        }}
                        label={`${t('Clinvar associated literature')} (${
                          clinvarArticles ? clinvarArticles.length : 0
                        })`}
                        {...a11yProps(1)}
                      />

                      <Tab
                        sx={{
                          textTransform: 'capitalize'
                        }}
                        label={`${t('Real-time search')}(${
                          (litVarArticles?.count ?? 0) +
                          (scholarArticles ? scholarArticles.length : 0)
                        })`}
                        {...a11yProps(2)}
                      />

                      {/* <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`LitVar (${props.litVarArticles?.count ?? 0})`}
                          {...a11yProps(2)}
                        /> */}

                      <Tab
                        sx={{
                          textTransform: 'capitalize'
                        }}
                        label={`${t('Free version of HGMD')}`}
                        {...a11yProps(3)}
                      />
                    </Tabs>
                    {variantsArticles && variantsArticles.details ? (
                      <CustomTabPanel value={tabValueArticle} index={0}>
                        <Box>
                          <Typography
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '0 2.25rem',
                              fontSize: '1.15rem'
                            }}
                            minHeight={50}
                            component={'h5'}
                          >
                            Pubmed Articles
                          </Typography>

                          <Divider />

                          <Box>
                            <Box
                              sx={{
                                padding: '10px',
                                border: '1px solid #5db5f9'
                              }}
                            >
                              {variantsArticles &&
                              variantsArticles.details &&
                              variantsArticles.details[0]?.pubmed_articles
                                ?.summarization ? (
                                <React.Fragment>
                                  <Typography
                                    fontSize={'18px'}
                                    fontWeight={600}
                                  >
                                    Literature Summary:
                                  </Typography>

                                  <Typography
                                    py={4}
                                    sx={{
                                      overflow: 'hidden',
                                      wordBreak: 'break-word',
                                      whiteSpace: 'pre-wrap',
                                      fontSize: '1rem'
                                    }}
                                    component={'pre'}
                                  >
                                    {summarization}
                                  </Typography>
                                </React.Fragment>
                              ) : (
                                <Typography paddingLeft={'2.25rem'}>
                                  No Pubmed Articles
                                </Typography>
                              )}
                            </Box>
                            <Box>
                              {variantsArticles &&
                              variantsArticles.details &&
                              variantsArticles.details[0]?.pubmed_articles
                                ?.summarization ? (
                                <React.Fragment>
                                  <Typography
                                    py={4}
                                    sx={{
                                      overflow: 'hidden',
                                      wordBreak: 'break-word',
                                      whiteSpace: 'pre-wrap',
                                      fontSize: '1rem'
                                    }}
                                  >
                                    {Comment}
                                  </Typography>
                                </React.Fragment>
                              ) : (
                                <Typography paddingLeft={'2.25rem'}>
                                  No Clinvar Comment(s)
                                </Typography>
                              )}

                              <Divider />
                            </Box>

                            {variantsArticles && variantsArticles.details
                              ? variantsArticles.details[0]?.pubmed_articles?.literatures?.map(
                                  (items: any) => {
                                    return (
                                      <Article
                                        value={items}
                                        type="variants"
                                        row={{}}
                                        handleOpen={() => {
                                          //
                                        }}
                                        key={items.pmid}
                                        summarization={''}
                                      />
                                    )
                                  }
                                )
                              : ''}
                          </Box>
                        </Box>
                      </CustomTabPanel>
                    ) : (
                      ''
                    )}
                    <CustomTabPanel
                      value={tabValueArticle}
                      index={
                        variantsArticles && variantsArticles.details ? 1 : 0
                      }
                    >
                      {clinvarArticles
                        ? clinvarArticles.map((items) => {
                            return (
                              <Article
                                value={items}
                                type="clinvar"
                                row={props.value}
                                handleOpen={() => {
                                  //
                                }}
                              />
                            )
                          })
                        : ''}
                    </CustomTabPanel>
                    <CustomTabPanel
                      value={tabValueArticle}
                      index={
                        variantsArticles && variantsArticles.details ? 2 : 1
                      }
                    >
                      <Tabs
                        value={tabValueArticle2}
                        onChange={(e, value) => setTabValueArticle2(value)}
                        aria-label="basic tabs example"
                        sx={{
                          position: 'relative'
                        }}
                      >
                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`LitVar (${litVarArticles?.count ?? 0})`}
                          {...a11yProps(0)}
                        />

                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`Google Scholar(${
                            scholarArticles ? scholarArticles.length : 0
                          })`}
                          {...a11yProps(1)}
                        />
                      </Tabs>
                      <CustomTabPanel value={tabValueArticle2} index={0}>
                        {litVarArticles &&
                        litVarArticles.count &&
                        litVarArticles.page_size ? (
                          <Stack
                            spacing={2}
                            alignItems="center"
                            justifyContent={'center'}
                            py={2}
                          >
                            <Typography>
                              {`Showing 1 to ${litVarArticles.page_size} of ${litVarArticles.count} publications.`}
                            </Typography>

                            <Pagination
                              count={Math.ceil(
                                litVarArticles.count / litVarArticles.page_size
                              )}
                              renderItem={(item) => (
                                <PaginationItem
                                  slots={{
                                    previous: ArrowBackIcon,
                                    next: ArrowForwardIcon
                                  }}
                                  {...item}
                                />
                              )}
                              page={litPage}
                              onChange={(e, value) => {
                                setLitPage(value)

                                const rsId =
                                  props.value.rs_id || props.value.rsid
                                getLitVarArticle.mutateAsync({
                                  rsId,
                                  litPage: value
                                })
                              }}
                            />
                          </Stack>
                        ) : (
                          ''
                        )}

                        {litVarArticles &&
                        litVarArticles.results &&
                        Array.isArray(litVarArticles.results)
                          ? litVarArticles.results.map((items: any) => {
                              return (
                                <Article
                                  value={items}
                                  type="LitVar"
                                  row={props.value}
                                  handleOpen={() => {
                                    //
                                  }}
                                />
                              )
                            })
                          : ''}
                      </CustomTabPanel>

                      <CustomTabPanel value={tabValueArticle2} index={1}>
                        {scholarArticles
                          ? scholarArticles.map((items) => {
                              return (
                                <Article
                                  value={items}
                                  type="scholar"
                                  row={props.value}
                                  handleOpen={() => {
                                    //
                                  }}
                                />
                              )
                            })
                          : ''}
                      </CustomTabPanel>
                    </CustomTabPanel>
                    <CustomTabPanel
                      value={tabValueArticle}
                      index={
                        variantsArticles && variantsArticles.details ? 3 : 2
                      }
                    >
                      <Box>
                        {hgmdValue.length ? (
                          <TableContainer
                            sx={{
                              minWidth: '100%',
                              width: 'max-content'
                            }}
                          >
                            <Table>
                              <TableBody>
                                {hgmdValue.map((item) => {
                                  return (
                                    <TableRow key={item?.name}>
                                      <TableCell
                                        sx={{
                                          paddingBottom: '8px !important',
                                          paddingTop: '8px !important',
                                          paddingRight: 0
                                        }}
                                      >
                                        {item?.name}
                                      </TableCell>

                                      <TableCell
                                        sx={{
                                          textAlign: 'right',
                                          paddingBottom: '8px !important',
                                          paddingTop: '8px !important',
                                          paddingRight: 0
                                        }}
                                      >
                                        {item?.value}
                                      </TableCell>
                                    </TableRow>
                                  )
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : (
                          <Typography textAlign={'center'}>
                            {t('No Results')}
                          </Typography>
                        )}
                      </Box>
                    </CustomTabPanel>
                  </CardContent>
                </Card>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <BootstrapDialog
        onClose={() => setLogsOpen(!logsOpen)}
        aria-labelledby="customized-dialog-title"
        open={logsOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('Instructions')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setLogsOpen(!logsOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ minWidth: 1200 }}>
          <Tables
            rows={tableData2 as Item[]}
            columns={columns3}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 99
                }
              }
            }}
            pageSizeOptions={[100]}
            checkboxSelection={false}
            disableRowSelectionOnClick
            disableColumnMenu
            disableVirtualization
            rowCount={allUserAcmgCount}
            slots={null}
            sx={{
              '& .MuiDataGrid-footerContainer': {
                justifyContent: 'center',
                display: 'none'
              },
              '& .MuiDataGrid-columnHeaders': {
                bgcolor: '#EDEFF0'
              }
            }}
          />
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={() => setAiOpen(!aiOpen)}
        aria-labelledby="customized-dialog-title"
        open={aiOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('Articles')}
          {`:(${props.value?.gene},${
            props.value?.c_nomen ?? props.value?.hgvsp
          },${props.value?.p_nomen ?? props.value?.hgvsc})`}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setAiOpen(!aiOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ minWidth: 600 }}>
          <Card>
            <CardContent>
              {variantsArticles &&
              variantsArticles.details &&
              variantsArticles.details[0]?.pubmed_articles?.summarization ? (
                <React.Fragment>
                  <Typography
                    fontSize={18}
                    color="#237aaa"
                    py={4}
                    sx={{
                      overflow: 'hidden',
                      wordBreak: 'break-word',
                      whiteSpace: 'pre-wrap'
                    }}
                  >
                    {translates
                      ? translates
                      : variantsArticles.details[0]?.pubmed_articles
                          ?.summarization}
                  </Typography>
                </React.Fragment>
              ) : (
                ''
              )}

              {variantsArticles && variantsArticles.details ? (
                <React.Fragment>
                  <Stack direction={'row'} spacing={2}>
                    <Typography fontSize={18} color="#237aaa" py={1}>
                      {'ACMG Classification:'}
                    </Typography>

                    <Box
                      sx={{
                        p: 2,
                        color: 'white',
                        backgroundColor:
                          ACMGClassification.find(
                            (item) =>
                              item.key ===
                                variantsArticles.details[0]
                                  ?.acmg_classification ||
                              item.title ===
                                variantsArticles.details[0]?.acmg_classification
                          )?.color ?? 'rgba(229,38,35,0.8)',
                        borderRadius: '5px'
                      }}
                    >
                      {variantsArticles.details[0]?.acmg_classification}
                    </Box>
                  </Stack>

                  <Typography fontSize={18} color="#237aaa" py={1}>
                    {'ACMG Evidence:'}
                  </Typography>

                  {acmg && acmg.length
                    ? acmg.map((item: string) => {
                        return (
                          <Typography fontSize={16} pt={2}>
                            <Typography>{item}</Typography>
                          </Typography>
                        )
                      })
                    : ''}

                  <Stack
                    direction={'row'}
                    justifyContent="space-between"
                    py={2}
                  >
                    <Paper
                      component="form"
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: 400,
                        height: '3rem'
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder={`${t(
                          'Please enter PMID and press Enter'
                        )}`}
                        inputProps={{ 'aria-label': 'search' }}
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value)
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault()

                            setSearchValue(search)
                          }
                        }}
                      />

                      <IconButton
                        type="button"
                        sx={{ p: '10px' }}
                        aria-label="search"
                        onClick={() => {
                          setSearchValue(search)
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </Paper>

                    <Box display={'flex'} alignItems="center">
                      <Button
                        variant="contained"
                        size="small"
                        onClick={async () => {
                          if (translates) {
                            setAcmg(
                              variantsArticles.details[0]?.acmg
                                ?.filter((item: any) => item.code_status)
                                .map(
                                  (item: any) =>
                                    `${item.code_name}//${
                                      item.code_strength ?? ''
                                    }//${item.evidence}`
                                )
                            )

                            return setTranslates('')
                          }
                          const sourceLanguage = 'en',
                            targetLanguage = 'zh'

                          const params: TranslateDto = {
                            sourceText:
                              variantsArticles.details[0]?.pubmed_articles
                                ?.summarization,
                            sourceLanguage,
                            targetLanguage
                          }

                          if (params.sourceText) {
                            const data = await Translate.mutateAsync(params)

                            setTranslates(data)
                          }

                          const datas = await Promise.all(
                            acmg.map(async (item) => {
                              const params: TranslateDto = {
                                sourceText: item,
                                sourceLanguage,
                                targetLanguage
                              }

                              return await Translate.mutateAsync(params)
                            })
                          )

                          setAcmg(datas)
                        }}
                      >
                        {t('translate')}
                      </Button>
                    </Box>
                  </Stack>
                </React.Fragment>
              ) : (
                ''
              )}

              {variantsArticles && variantsArticles.details
                ? variantsArticles.details[0]?.pubmed_articles?.literatures
                    ?.filter(
                      (item: any) =>
                        item.pmid && `${item.pmid}`.includes(searchValue)
                    )
                    .map((items: any) => {
                      return (
                        <Article
                          acmg={variantsArticles.details[0]?.acmg
                            ?.filter((item: any) => item.code_status)
                            .map(
                              (item: any) =>
                                `${item.code_name}:${item.evidence}`
                            )}
                          acmg_classification={
                            variantsArticles.details[0]?.acmg_classification
                          }
                          acmg_summary={
                            variantsArticles.details[0]?.acmg_summary
                          }
                          value={items}
                          type="variants"
                          row={props.value}
                          handleOpen={() => {
                            //
                          }}
                          summarization={''}
                        />
                      )
                    })
                : ''}
            </CardContent>
          </Card>
        </DialogContent>
      </BootstrapDialog>
    </Box>
  )
})

export default ACMG
